// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Theory {
  display: grid;
  justify-content: center;
  align-items: start;
  margin: 0 auto;
  padding: 0;
  height: 180svh;
  max-width: 68.6%;
  text-align: center;
}

.Theory__Caption {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  align-items: start;
  position: sticky;
  bottom: 0;
  left: 0;
}

.Theory__Caption p {
  grid-column: 3 / 4;
  color: white;
  font-size: 18px;
  font-weight: normal;
  padding-bottom: 1.5em;
}

.Theory__Caption2 {
  color: white;
  font-size: 18px;
  font-weight: normal;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 10svh;
}

.image-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* Change to center for better mobile alignment */
  justify-content: center;
  transition: transform 0.3s ease, opacity 0.3s ease;
  scroll-behavior: smooth;
  width: 70%; /* Adjusted for better mobile responsiveness */
  margin: 0 auto;
}

.rotating-image {
  max-width: 800px; /* Adjusted for better mobile responsiveness */
  height: auto;
  margin: 0 auto;
}

.Theory_Brief {
  height: 120svh;
  padding: 0;
  margin: 0;
  width: 100%;
  overflow: auto !important;
  -ms-overflow-style: none;
}
.Theory_Brief::-webkit-scrollbar {
  display: none;
}

.Triangle_main_mobile {
  display: flex !important;
  max-width: 100vw;
  height: 100svh;
  justify-content: center;
  align-items: center;
}

.FixImages {
  height: 110svh !important;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1em;
  margin-right: 1em;
}

.Tecno__Section {
  position: absolute;
  display: "grid";
  grid-template-columns: 1fr 1fr;
  gap: 1em;
  top: 50%;
  /* height: 55%; */
  width: 80%;
  justify-content: center;
  align-items: center;
}

.Tecno__Text {
  color: white;
  font-size: 18px;
  width: 70%;
  height: 95px;
  position: static;
  justify-self: center;
  align-self: flex-end;
  height: 25svh;
  display: flex;
}

.Tecno__Text p {
  align-self: flex-end;
}

.Tecno__Button {
  color: white;
  font-size: 18px;
  font-weight: bold;
  opacity: 60%;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  position: static;
  justify-self: left;
  align-self: flex-start;
}

.Autor__Section {
  position: absolute;
  display: "grid";
  grid-template-columns: 1fr 1fr;
  gap: 1em;
  top: 50%;
  /* height: 55%; */
  width: 80%;
  justify-content: center;
  align-items: center;
}

.Autor__Text {
  color: white;
  font-size: 18px;
  width: 70%;
  height: 95px;
  position: static;
  justify-self: center;
  align-self: flex-end;
  height: 25svh;
  display: flex;
}

.Autor__Text p {
  align-self: flex-end;
}

.Autor__Button {
  color: white;
  font-size: 18px;
  font-weight: bold;
  opacity: 60%;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  position: static;
  justify-self: left;
  align-self: flex-start;
}

.Programa__Section {
  position: absolute;
  display: "grid";
  grid-template-columns: 1fr 1fr;
  gap: 1em;
  top: 50%;
  /* height: 55%; */
  width: 80%;
  justify-content: center;
  align-items: center;
}

.Programa__Text {
  color: white;
  font-size: 18px;
  width: 70%;
  height: 95px;
  position: static;
  justify-self: left;
  align-self: flex-end;
  height: 32.5svh;
  display: flex;
}

.Programa__Text p {
  align-self: flex-end;
}

.Programa__Button {
  color: white;
  font-size: 18px;
  font-weight: bold;
  opacity: 60%;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  position: static;
  justify-self: left;
  align-self: flex-start;
}

.Design__Section {
  position: absolute;
  display: "grid";
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1em;
  top: 50%;
  /* height: 55%; */
  width: 80%;
  justify-content: center;
  align-items: center;
}

.Design__Text {
  color: white;
  font-size: 18px;
  width: 95%;
  height: 95px;
  position: static;
  justify-self: left;
  align-self: flex-start;
  height: 32.5svh;
  display: flex;
  grid-column: 3 / 4;
}

.Design__Button {
  color: white;
  font-size: 18px;
  font-weight: bold;
  opacity: 60%;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  position: static;
  justify-self: left;
  align-self: flex-start;
}

.NextButton {
  color: white;
  font-size: 18px;
  font-weight: bold;
  opacity: 60%;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  position: static;
  justify-self: right;
  align-self: flex-start;
}

.Tecno__Section {
  display: none;
}

.Autor__Section {
  display: none;
}

.Programa__Section {
  display: none;
}

.Design__Section {
  display: none;
}

.show {
  display: grid;
  z-index: 10;
}

.workplz {
  max-height: 100svh !important;
  max-width: 100vw !important;
  width: 90%;
  height: auto;
}

.Main {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100svh;
  width: 100vw;
}

.fixedNav {
  position: relative;
  height: min-content;
}

.false {
  cursor: pointer;
}

.hidden {
  display: none;
}

.endAforismos {
  display: grid;
  color: white;
  position: fixed;
  left: 0;
  top: 0;
  height: 100svh;
  width: 100vw;
  justify-content: center !important;
  align-items: center;
}

@media all and (min-width: 1921px) {
  .Autor__Section {
    position: absolute;
    display: "grid";
    grid-template-columns: 1fr 1fr;
    gap: 1em;
    top: 50%;
    /* height: 55%; */
    width: 80%;
    justify-content: center;
    align-items: center;
  }

  .Autor__Text {
    color: white;
    font-size: 18px;
    width: 70%;
    height: 95px;
    position: static;
    justify-self: center;
    align-self: flex-end;
    height: 25svh;
    display: flex;
  }

  .Autor__Text p {
    align-self: flex-end;
  }

  .Autor__Button {
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: static;
    justify-self: left;
    align-self: flex-start;
  }

  .Programa__Section {
    position: absolute;
    display: "grid";
    grid-template-columns: 1fr 1fr;
    gap: 1em;
    top: 50%;
    /* height: 55%; */
    width: 80%;
    justify-content: center;
    align-items: center;
  }

  .Programa__Text {
    color: white;
    font-size: 18px;
    width: 70%;
    height: 95px;
    position: static;
    justify-self: left;
    align-self: flex-end;
    height: 32.5svh;
    display: flex;
  }

  .Programa__Text p {
    align-self: flex-end;
  }

  .Programa__Button {
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: static;
    justify-self: left;
    align-self: flex-start;
  }

  .Design__Section {
    position: absolute;
    display: "grid";
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 1em;
    top: 50%;
    /* height: 55%; */
    width: 80%;
    justify-content: center;
    align-items: center;
  }

  .Design__Text {
    color: white;
    font-size: 18px;
    width: 95%;
    height: 95px;
    position: static;
    justify-self: left;
    align-self: flex-start;
    height: 32.5svh;
    display: flex;
    grid-column: 3 / 4;
  }

  .Design__Button {
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: static;
    justify-self: left;
    align-self: flex-start;
  }

  .NextButton {
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: static;
    justify-self: right;
    align-self: flex-start;
  }

  /* Aforismos */

  .Theory__Aforismos {
    background-color: black;
    height: auto;
    padding: 0;
    margin: 0;
    display: block;
  }

  .Aforismo_1_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    justify-items: left;
    align-items: center !important;
  }

  .line {
    grid-column: 1 / 2;
    position: static;
    color: white;
    border-left: 1px solid white;
    min-height: 50%;
    z-index: 2;
    justify-self: right;
    align-self: flex-start;
    margin: 0;
    display: none;
  }

  .Info__1 {
    display: grid;
    grid-column: 2 / 5;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: relative;
    top: 10%;
    left: -2.5%;
    max-width: 100%;
    align-items: start;
  }

  .Info__1__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__1__1 p {
    font-size: 18px;
  }

  .Info__1__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_1 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_1 img {
    object-fit: cover;
    object-position: 50% 70%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_2_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 80svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
  }

  .A2_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 2.5rem;
    left: 3.8rem;
    color: white;
    height: 290px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
    align-self: self-end;
  }

  .Info__2 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 2 / 3;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__2__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__2__1 p {
    font-size: 18px;
  }

  .Info__2__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_2 img {
    object-fit: cover;
    object-position: 50% 45%;
    height: 100%;
    width: 100%;
  }

  .line2 {
    position: fixed;
    top: 0;
    left: 41%;
    color: white;
    border-left: 20px solid white;
    min-height: 605px;
    z-index: 2;
    display: none;
  }

  .fullscreen2 {
    height: 75svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 12.5%;
    left: 0;
    padding-left: 2.5vw;
    padding-right: 2.5vw;
  }

  .fullscreen2 img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }

  .Aforismo_3_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
  }

  .A3_Animation {
    position: fixed;
    bottom: 100%;
    left: 45%;
    color: white;
    height: 190px;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__3 {
    display: grid;
    grid-column: 2 / 5;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__3__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__3__1 p {
    font-size: 18px;
  }

  .Info__3__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Aforismo_4_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
  }

  .A4_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 5rem;
    left: 0;
    color: white;
    height: auto;
    width: 100%;
    z-index: 2;
    display: none;
    align-self: self-start;
  }

  .Info__4 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__4__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__4__1 p {
    font-size: 18px;
  }

  .Info__4__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_4 img {
    object-fit: cover;
    object-position: 50% 100%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_5_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
  }

  .Aforismo_5_Animation_Grid {
    grid-column: 3 / 5;
    grid-row: 1 / 2;
    display: grid;
    gap: 0;
    grid-template-columns: 1fr 1fr;
    color: white;
    position: static;
  }

  .A5_1_Animation {
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A5_2_Animation {
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__5 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__5__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__5__1 p {
    font-size: 18px;
  }

  .Info__5__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen3 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen3 img {
    object-fit: scale-down;
    height: 100%;
    width: 100%;
  }

  .Aforismo_6_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
  }

  .Info__6 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__6__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__6__1 p {
    font-size: 18px;
  }

  .Info__6__2 p {
    font-size: 18px;
    margin: 0;
  }

  /* src/MouseParallax.css */
  .mouse-parallax-container {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .background-blurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: blur(2px); /* Add a blur effect to the background */
  }

  .background-unblurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: none; /* No blur effect on the unblurred content */
  }

  .mouse-cursor {
    position: absolute;
    width: 100px;
    height: 100px;
    border: 2px solid #fff;
    border-radius: 50%;
    pointer-events: none; /* Prevent cursor from affecting other elements */
    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */
    transform: translate(-50%, -50%);
  }

  .fullscreen_6 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_6 img {
    object-fit: cover;
    object-position: 50% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_7_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .A7_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 500px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .Info__7 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__7__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__7__1 p {
    font-size: 18px;
  }

  .Info__7__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Aforismo_8_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .A8_1_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .A8_2_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    pointer-events: none;
  }

  .Info__8 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__8__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__8__1 p {
    font-size: 18px;
  }

  .Info__8__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen4 img {
    object-fit: cover;
    object-position: 50% 30%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_9_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .Info__9__title {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    color: white;
    position: static;
    max-width: 100%;
    justify-self: center;
    justify-content: left;
    align-items: start;
  }

  .Info_9_title_1 {
    grid-column: 1 / 2;
  }

  .Info_9_title_2 {
    grid-column: 2 / 3;
  }

  .A9_1_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: 0;
    color: white;
    height: 200px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A9_2_Animation {
    grid-column: 3 / 5;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: -3svh;
    color: white;
    height: 200px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__9 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__9__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__9__1 p {
    font-size: 18px;
  }

  .Info__9__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_9 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_9 img {
    object-fit: cover;
    object-position: 50% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_10_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .A10_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: auto;
    width: 60%;
    z-index: 40;
    display: none;
    justify-self: center;
  }

  .Info__10 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__10__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__10__1 p {
    font-size: 18px;
  }

  .Info__10__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_10 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_10 img {
    object-fit: cover;
    object-position: 50% 50%;
    height: 100%;
    width: 100%;
  }

  .endAforismos {
    display: grid;
    color: white;
    position: fixed;
    left: 0;
    top: 0;
    height: 100svh;
    width: 100vw;
    justify-content: center !important;
    align-items: center;
  }

  .BG_info {
    position: fixed;
    left: 15.7%;
    bottom: 10%;
    color: white;
  }

  .BG_info h1 {
    font-size: 18px;
    font-weight: bolder;
    line-height: 1em;
  }

  .BG_info p {
    font-size: 18px;
  }
}

@media all and (min-width: 1441px) and (max-width: 1920px) {
  /* Aforismos */

  .Theory__Aforismos {
    background-color: black;
    height: 500svh;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Aforismo_1_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    justify-items: left;
    align-items: center !important;
  }

  .line {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: relative;
    left: 20px;
    color: white;
    border-left: 1px solid white;
    min-height: 45%;
    z-index: 2;
    justify-self: right;
    align-self: flex-start;
    margin: 0;
    display: none;
  }

  .Info__1 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
  }

  .Info__1__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__1__1 p {
    font-size: 18px;
  }

  .Info__1__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_1 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_1 img {
    object-fit: cover;
    object-position: 50% 60%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_2_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
  }

  .A2_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: -10.35rem;
    left: 3.8rem;
    color: white;
    height: 290px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
    align-self: center;
  }

  .Info__2 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__2__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__2__1 p {
    font-size: 18px;
  }

  .Info__2__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_2 img {
    object-fit: cover;
    object-position: 50% 50%;
    height: 100%;
    width: 100%;
  }

  .line2 {
    position: relative;
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    color: white;
    border-left: 20px solid white;
    min-height: 605px;
    z-index: 2;
    display: none;
    justify-self: center;
    align-self: flex-end;
  }

  .fullscreen2 {
    height: 75svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 12.5%;
    left: 0;
    padding-left: 2.5vw;
    padding-right: 2.5vw;
  }

  .fullscreen2 img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }

  .Aforismo_3_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
  }

  .A3_Animation {
    position: relative;
    grid-column: 1 / 5;
    grid-row: 1 /2;
    color: white;
    height: 190px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
    align-self: start;
  }

  .Info__3 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 /2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: center;
  }

  .Info__3__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__3__1 p {
    font-size: 18px;
  }

  .Info__3__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Aforismo_4_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
  }

  .A4_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 5rem;
    left: 0;
    color: white;
    height: auto;
    width: 100%;
    z-index: 2;
    display: none;
    align-self: self-start;
  }

  .Info__4 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__4__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__4__1 p {
    font-size: 18px;
  }

  .Info__4__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_4 img {
    object-fit: cover;
    object-position: 50% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_5_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
  }

  .Aforismo_5_Animation_Grid {
    grid-column: 3 / 5;
    grid-row: 1 / 2;
    display: grid;
    gap: 0;
    grid-template-columns: 1fr 1fr;
    color: white;
    position: static;
  }

  .A5_1_Animation {
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A5_2_Animation {
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__5 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__5__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__5__1 p {
    font-size: 18px;
  }

  .Info__5__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen3 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen3 img {
    object-fit: scale-down;
    height: 100%;
    width: 100%;
  }

  .Aforismo_6_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
  }

  .Info__6 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__6__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__6__1 p {
    font-size: 18px;
  }

  .Info__6__2 p {
    font-size: 18px;
    margin: 0;
  }

  /* src/MouseParallax.css */
  .mouse-parallax-container {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .background-blurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: blur(2px); /* Add a blur effect to the background */
  }

  .background-unblurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: none; /* No blur effect on the unblurred content */
  }

  .mouse-cursor {
    position: absolute;
    width: 100px;
    height: 100px;
    border: 2px solid #fff;
    border-radius: 50%;
    pointer-events: none; /* Prevent cursor from affecting other elements */
    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */
    transform: translate(-50%, -50%);
  }

  .fullscreen_6 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_6 img {
    object-fit: cover;
    object-position: 50% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_7_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .A7_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 500px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .Info__7 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__7__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__7__1 p {
    font-size: 18px;
  }

  .Info__7__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Aforismo_8_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
    justify-content: center;
    z-index: 500;
  }

  .A8_1_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 30%;
    width: auto;
    display: none;
    justify-self: center;
    z-index: 1000;
  }

  .A8_2_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 300px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    pointer-events: none;
  }

  .Info__8 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__8__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__8__1 p {
    font-size: 18px;
  }

  .Info__8__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen4 img {
    object-fit: cover;
    object-position: 50% 20%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_9_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .Info__9__title {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    color: white;
    position: static;
    max-width: 100%;
    justify-self: center;
    justify-content: left;
    align-items: start;
  }

  .Info_9_title_1 {
    grid-column: 1 / 2;
  }

  .Info_9_title_2 {
    grid-column: 2 / 3;
  }

  .A9_1_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: 0;
    color: white;
    height: 200px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A9_2_Animation {
    grid-column: 3 / 5;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: -3svh;
    color: white;
    height: 200px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__9 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__9__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__9__1 p {
    font-size: 18px;
  }

  .Info__9__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_9 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_9 img {
    object-fit: cover;
    object-position: 50% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_10_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 15.7%;
    top: 0;
    gap: 20px;
    max-width: 68.6%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .A10_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: auto;
    width: 80%;
    z-index: 40;
    display: none;
    justify-self: center;
  }

  .Info__10 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__10__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__10__1 p {
    font-size: 18px;
  }

  .Info__10__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_10 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_10 img {
    object-fit: cover;
    object-position: 50% 50%;
    height: 100%;
    width: 100%;
  }

  .endAforismos {
    display: grid;
    color: white;
    position: fixed;
    left: 0;
    top: 0;
    height: 100svh;
    width: 100vw;
    justify-content: center !important;
    align-items: center;
  }

  .BG_info {
    position: fixed;
    left: 50%;
    bottom: 5%;
    color: white;
  }

  .BG_info h1 {
    font-size: 18px;
    font-weight: bolder;
    line-height: 1em;
  }

  .BG_info p {
    font-size: 18px;
  }
}

@media all and (min-width: 1025px) and (max-width: 1440px) {
  /* Laptop L */

  /* Aforismos */

  .Theory__Aforismos {
    background-color: black;
    height: 500svh;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Aforismo_1_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 10%;
    top: 0;
    gap: 20px;
    max-width: 80%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line {
    grid-column: 1 / 2;
    position: static;
    color: white;
    border: 1px solid white;
    min-height: 50%;
    z-index: 2;
    justify-self: right;
    align-self: flex-start;
    margin: 0;
    display: none;
  }

  .Info__1 {
    display: grid;
    grid-column: 2 / 5;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: relative;
    top: 10%;
    left: -1.5rem;
    max-width: 100%;
    align-items: start;
  }

  .Info__1__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__1__1 p {
    font-size: 18px;
  }

  .Info__1__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_1 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_1 img {
    object-fit: cover;
    object-position: 50% 80%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_2_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 80svh;
    position: fixed;
    margin: 0 auto;
    left: 10%;
    top: 0;
    gap: 20px;
    max-width: 80%;
    width: 100%;
  }

  .A2_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 2.5rem;
    left: 3.8rem;
    color: white;
    height: 290px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
    align-self: self-end;
  }

  .Info__2 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 2 / 3;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__2__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__2__1 p {
    font-size: 18px;
  }

  .Info__2__2 p {
    font-size: 18px;
    margin: 0;
  }

  .line2 {
    position: fixed;
    top: 0;
    left: 41%;
    color: white;
    border-left: 20px solid white;
    min-height: 605px;
    z-index: 2;
    display: none;
  }

  .fullscreen_2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_2 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_3_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 10%;
    top: 0;
    gap: 20px;
    max-width: 80%;
    width: 100%;
    align-items: center;
  }

  .A3_Animation {
    position: fixed;
    bottom: 100%;
    left: 45%;
    color: white;
    height: 190px;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__3 {
    display: grid;
    grid-column: 2 / 5;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__3__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__3__1 p {
    font-size: 18px;
  }

  .Info__3__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen2 {
    height: 75svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 12.5%;
    left: 0;
    padding-left: 2.5vw;
    padding-right: 2.5vw;
  }

  .fullscreen2 img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }

  .Aforismo_4_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 10%;
    top: 0;
    gap: 20px;
    max-width: 80%;
    width: 100%;
    align-items: center;
  }

  .A4_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 5rem;
    left: 0;
    color: white;
    height: auto;
    width: 100%;
    z-index: 2;
    display: none;
    align-self: self-start;
  }

  .Info__4 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__4__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__4__1 p {
    font-size: 18px;
  }

  .Info__4__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_4 img {
    object-fit: cover;
    object-position: 50% 80%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_5_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 10%;
    top: 0;
    gap: 20px;
    max-width: 80%;
    width: 100%;
    align-items: center;
  }

  .Aforismo_5_Animation_Grid {
    grid-column: 3 / 5;
    grid-row: 1 / 2;
    display: grid;
    gap: 0;
    grid-template-columns: 1fr 1fr;
    color: white;
    position: static;
  }

  .A5_1_Animation {
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A5_2_Animation {
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__5 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__5__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__5__1 p {
    font-size: 18px;
  }

  .Info__5__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen3 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen3 img {
    object-fit: scale-down;
    height: 100%;
    width: 100%;
  }

  .Aforismo_6_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 10%;
    top: 0;
    gap: 20px;
    max-width: 80%;
    width: 100%;
    align-items: center;
  }

  .Info__6 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__6__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__6__1 p {
    font-size: 18px;
  }

  .Info__6__2 p {
    font-size: 18px;
    margin: 0;
  }

  /* src/MouseParallax.css */
  .mouse-parallax-container {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .background-blurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: blur(2px); /* Add a blur effect to the background */
  }

  .background-unblurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: none; /* No blur effect on the unblurred content */
  }

  .mouse-cursor {
    position: absolute;
    width: 100px;
    height: 100px;
    border: 2px solid #fff;
    border-radius: 50%;
    pointer-events: none; /* Prevent cursor from affecting other elements */
    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */
    transform: translate(-50%, -50%);
  }

  .fullscreen_6 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_6 img {
    object-fit: cover;
    object-position: 50% 80%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_7_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 10%;
    top: 0;
    gap: 20px;
    max-width: 80%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .A7_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .Info__7 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__7__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__7__1 p {
    font-size: 18px;
  }

  .Info__7__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Aforismo_8_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 10%;
    top: 0;
    gap: 20px;
    max-width: 80%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .A8_1_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .A8_2_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    pointer-events: none;
  }

  .Info__8 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__8__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__8__1 p {
    font-size: 18px;
  }

  .Info__8__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen4 img {
    object-fit: cover;
    object-position: 50% 20%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_9_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 10%;
    top: 0;
    gap: 20px;
    max-width: 80%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .Info__9__title {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    color: white;
    position: static;
    max-width: 100%;
    justify-self: center;
    justify-content: left;
    align-items: start;
  }

  .Info_9_title_1 {
    grid-column: 1 / 2;
  }

  .Info_9_title_2 {
    grid-column: 2 / 3;
  }

  .A9_1_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: 0;
    color: white;
    height: 200px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A9_2_Animation {
    grid-column: 3 / 5;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: -1.5rem;
    color: white;
    height: 200px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__9 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__9__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__9__1 p {
    font-size: 18px;
  }

  .Info__9__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_9 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_9 img {
    object-fit: cover;
    object-position: 50% 80%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_10_Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 10%;
    top: 0;
    gap: 20px;
    max-width: 80%;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .A10_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: auto;
    width: 80%;
    z-index: 40;
    display: none;
    justify-self: center;
  }

  .Info__10 {
    display: grid;
    grid-column: 2 / 5;
    grid-row: 1 / 2;
    grid-template-columns: 1fr 1.9fr;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__10__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__10__1 p {
    font-size: 18px;
  }

  .Info__10__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_10 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_10 img {
    object-fit: cover;
    object-position: 100% 80%;
    height: 100%;
    width: 100%;
  }

  .endAforismos {
    display: grid;
    color: white;
    position: fixed;
    left: 0;
    top: 0;
    height: 100svh;
    width: 100vw;
    justify-content: center !important;
    align-items: center;
  }

  .BG_info {
    position: fixed;
    left: 10%;
    bottom: 10%;
    color: white;
  }

  .BG_info h1 {
    font-size: 18px;
    font-weight: bolder;
    line-height: 1em;
  }

  .BG_info p {
    font-size: 18px;
  }
}

@media all and (min-width: 769px) and (max-width: 1024px) {
  /* Laptop aka Tablet L */

  .Theory {
    display: grid;
    justify-content: center;
    align-items: start;
    margin: 0 auto;
    padding: 0;
    height: 200svh;
    max-width: 68.6%;
    text-align: center;
  }

  .image-container {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    justify-self: center !important;
    transition: transform 0.3s ease, opacity 0.3s ease;
    scroll-behavior: smooth;
    width: -moz-fit-content;
    width: fit-content;
    margin: 0 auto;
  }

  .rotating-image {
    max-width: 800px;
    max-height: 800px;
    width: auto;
    height: auto;
    margin: 0 auto;
  }

  .Tecno__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Tecno__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Tecno__Text p {
    justify-self: start;
  }

  .Tecno__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Autor__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Autor__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Autor__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Programa__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Programa__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Programa__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Design__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Design__Text {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: center;
    display: flex;
  }

  .Design__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .NextButton {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 0;
    justify-self: center;
    align-self: center;
    height: auto;
  }

  .Tecno__Section {
    display: none;
  }

  .Autor__Section {
    display: none;
  }

  .Programa__Section {
    display: none;
  }

  .Design__Section {
    display: none;
  }

  .show {
    display: grid;
    z-index: 10;
  }

  /* Aforismos */

  .Theory__Aforismos {
    background-color: black;
    height: 500svh;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Aforismo_1_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    color: white;
    border: 1px solid white;
    min-height: 30%;
    z-index: 2;
    justify-self: left;
    align-self: flex-start;
    margin: 0;
    display: none;
  }

  .Info__1 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: relative;
    top: 2rem;
    left: 0;
    max-width: 100%;
    align-items: start;
  }

  .Info__1__1 h1 {
    font-size: 20px;
    font-weight: bolder;
    margin: 0;
  }

  .Info__1__1 p {
    font-size: 20px;
  }

  .Info__1__2 p {
    font-size: 20px;
    margin: 0;
  }

  .fullscreen_1 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_1 img {
    object-fit: cover;
    object-position: 50% 80%;
    height: 100%;
    width: 100%;
  }

  .BG_info {
    position: fixed;
    left: 5%;
    bottom: 5%;
    color: white;
  }

  .BG_info h1 {
    font-size: 18px;
    font-weight: bolder;
    line-height: 1em;
  }

  .BG_info p {
    font-size: 18px;
  }

  .Aforismo_2_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 87.75svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A2_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: fixed;
    top: 0.2rem;
    left: -2.725rem;
    color: white;
    height: 290px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
    align-self: self-start;
  }

  .Info__2 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: fixed;
    top: 17.05rem;
    left: 3.3rem;
    max-width: 90%;
    align-items: start;
  }

  .Info__2__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__2__1 p {
    font-size: 18px;
  }

  .Info__2__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_2 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_3_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line2 {
    position: fixed;
    top: 0;
    left: 10%;
    color: white;
    border-left: 20px solid white;
    min-height: 605px;
    z-index: 2;
    display: none;
  }

  .A3_Animation {
    position: fixed;
    bottom: 100%;
    left: 15%;
    color: white;
    height: 190px;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__3 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
  }

  .Info__3__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__3__1 p {
    font-size: 18px;
  }

  .Info__3__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen2 img {
    object-fit: contain;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_4_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A4_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 5rem;
    left: 0;
    color: white;
    height: auto;
    width: 100%;
    z-index: 2;
    display: none;
    align-self: self-end;
    justify-self: center;
  }

  .Info__4 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: fixed;
    top: 20rem;
    left: 3rem;
    max-width: 90%;
    align-items: start;
    justify-self: start;
  }

  .Info__4__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__4__1 p {
    font-size: 18px;
  }

  .Info__4__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_4 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_5_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Aforismo_5_Animation_Grid {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    display: grid;
    gap: 0;
    grid-template-columns: 1fr 1fr;
    color: white;
    position: static;
    width: 100%;
  }

  .A5_1_Animation {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    justify-self: end;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
  }

  .A5_2_Animation {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__5 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__5__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__5__1 p {
    font-size: 18px;
  }

  .Info__5__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen3 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen3 img {
    object-fit: scale-down;
    height: 100%;
    width: 100%;
  }

  .Aforismo_6_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Info__6 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__6__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__6__1 p {
    font-size: 18px;
  }

  .Info__6__2 p {
    font-size: 18px;
    margin: 0;
  }

  /* src/MouseParallax.css */
  .mouse-parallax-container {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .background-blurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: blur(2px); /* Add a blur effect to the background */
  }

  .background-unblurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: none; /* No blur effect on the unblurred content */
  }

  .mouse-cursor {
    position: absolute;
    width: 100px;
    height: 100px;
    border: 2px solid #fff;
    border-radius: 50%;
    pointer-events: none; /* Prevent cursor from affecting other elements */
    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */
    transform: translate(-50%, -50%);
  }

  .fullscreen_6 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_6 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_7_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A7_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 500px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .Info__7 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__7__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__7__1 p {
    font-size: 18px;
  }

  .Info__7__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Aforismo_8_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A8_1_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .A8_2_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    pointer-events: none;
  }

  .Info__8 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__8__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__8__1 p {
    font-size: 18px;
  }

  .Info__8__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen4 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_9_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Info__9__title {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    color: white;
    position: static;
    max-width: 100%;
    justify-self: center;
    justify-content: left;
    align-items: start;
  }

  .Info_9_title_1 {
    grid-column: 1 / 2;
  }

  .Info_9_title_2 {
    grid-column: 2 / 3;
  }

  .A9_1_Animation {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 150px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A9_2_Animation {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: -1rem;
    color: white;
    height: 150px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__9 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__9__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__9__1 p {
    font-size: 18px;
  }

  .Info__9__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_9 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_9 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_10_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A10_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: auto;
    width: 100%;
    z-index: 40;
    display: none;
    justify-self: center;
  }

  .Info__10 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__10__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__10__1 p {
    font-size: 18px;
  }

  .Info__10__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_10 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_10 img {
    object-fit: cover;
    object-position: 70% 50%;
    height: 100%;
    width: 100%;
  }
}

@media all and (min-width: 426px) and (max-width: 768px) {
  .Theory {
    display: grid;
    justify-content: center;
    align-items: start;
    margin: 0 auto;
    padding: 0;
    height: 200svh;
    max-width: 89.5%;
    text-align: center;
    padding-top: 17svh;
  }

  .Theory__Caption {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    align-items: start;
    margin: 0 auto;
    width: 89.5%;
    position: sticky;
    bottom: 0;
    left: 0;
  }

  .Theory__Caption p {
    grid-column: 1 / 2;
    color: white;
    font-size: 18px;
    font-weight: normal;
    padding-bottom: 1.5em;
  }

  .Theory__Caption2 {
    display: none;
  }

  .image-container {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    justify-self: center !important;
    transition: transform 0.3s ease, opacity 0.3s ease;
    scroll-behavior: smooth;
    width: min-content;
    margin: 0 auto;
  }

  .rotating-image {
    max-width: 400px; /* Adjusted for better mobile responsiveness */
    height: auto;
    margin: 0 auto;
  }

  .teste__mobile {
    position: fixed;
    top: 0;
    left: 0;
    height: 100svh;
    width: 100vw;
    display: grid;
    justify-content: center;
    align-items: center;
  }

  .Triangle_main_mobile {
    display: flex !important;
    max-width: 100vw;
    height: 100svh;
    justify-content: center;
    align-items: center;
  }

  .FixImages {
    height: 100svh !important;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 1em;
    margin-right: 1em;
  }

  /*Tablet*/

  .Tecno__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Tecno__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Tecno__Text p {
    justify-self: start;
  }

  .Tecno__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Autor__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Autor__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Autor__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Programa__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Programa__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Programa__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Design__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Design__Text {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: center;
    display: flex;
  }

  .Design__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .NextButton {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 0;
    justify-self: center;
    align-self: center;
    height: auto;
  }

  .Tecno__Section {
    display: none;
  }

  .Autor__Section {
    display: none;
  }

  .Programa__Section {
    display: none;
  }

  .Design__Section {
    display: none;
  }

  .show {
    display: grid;
    z-index: 10;
  }

  .workplz {
    max-height: 100svh !important;
    max-width: 100vw !important;
    width: 90%;
    height: auto;
  }

  .TecnoMobile {
    height: 30vw;
    width: 20vw;
    border: pink 1px solid;
  }

  .testeBG {
    height: 100svh;
    width: 100vw;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .img-responsive {
    width: 100%;
    height: auto;
  }

  .img-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
  }

  /* Aforismos */

  .Theory__Aforismos {
    background-color: black;
    height: 500svh;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Aforismo_1_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    color: white;
    border: 1px solid white;
    min-height: 30%;
    z-index: 2;
    justify-self: left;
    align-self: flex-start;
    margin: 0;
    display: none;
  }

  .Info__1 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: relative;
    top: 0;
    left: 0;
    max-width: 100%;
    align-items: start;
  }

  .Info__1__1 h1 {
    font-size: 20px;
    font-weight: bolder;
    margin: 0;
  }

  .Info__1__1 p {
    font-size: 20px;
  }

  .Info__1__2 p {
    font-size: 20px;
    margin: 0;
  }

  .fullscreen_1 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_1 img {
    object-fit: cover;
    object-position: 50% 80%;
    height: 100%;
    width: 100%;
  }

  .BG_info {
    position: fixed;
    left: 5%;
    bottom: 2.5%;
    color: white;
  }

  .BG_info h1 {
    font-size: 18px;
    font-weight: bolder;
    line-height: 1em;
  }

  .BG_info p {
    font-size: 18px;
  }

  .Aforismo_2_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 87.75svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A2_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: fixed;
    top: -1.5rem;
    left: -3.6rem;
    color: white;
    height: 290px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
    align-self: self-start;
  }

  .Info__2 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: fixed;
    top: 15.4rem;
    left: 2.4rem;
    max-width: 90%;
    align-items: start;
  }

  .Info__2__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__2__1 p {
    font-size: 18px;
  }

  .Info__2__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_2 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_3_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line2 {
    position: fixed;
    top: 0;
    left: 10%;
    color: white;
    border-left: 20px solid white;
    min-height: 605px;
    z-index: 2;
    display: none;
  }

  .A3_Animation {
    position: fixed;
    bottom: 100%;
    left: 15%;
    color: white;
    height: 190px;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__3 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
  }

  .Info__3__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__3__1 p {
    font-size: 18px;
  }

  .Info__3__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen2 img {
    object-fit: contain;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_4_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A4_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 5rem;
    left: 0;
    color: white;
    height: auto;
    width: 100%;
    z-index: 2;
    display: none;
    align-self: self-start;
    justify-self: center;
  }

  .Info__4 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
    z-index: 10;
  }

  .Info__4__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__4__1 p {
    font-size: 18px;
  }

  .Info__4__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_4 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_5_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Aforismo_5_Animation_Grid {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    display: grid;
    gap: 0;
    grid-template-columns: 1fr 1fr;
    color: white;
    position: static;
    width: 100%;
  }

  .A5_1_Animation {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    justify-self: end;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
  }

  .A5_2_Animation {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__5 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__5__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__5__1 p {
    font-size: 18px;
  }

  .Info__5__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen3 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen3 img {
    object-fit: scale-down;
    height: 100%;
    width: 100%;
  }

  .Aforismo_6_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Info__6 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__6__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__6__1 p {
    font-size: 18px;
  }

  .Info__6__2 p {
    font-size: 18px;
    margin: 0;
  }

  /* src/MouseParallax.css */
  .mouse-parallax-container {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .background-blurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: blur(2px); /* Add a blur effect to the background */
  }

  .background-unblurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: none; /* No blur effect on the unblurred content */
  }

  .mouse-cursor {
    position: absolute;
    width: 100px;
    height: 100px;
    border: 2px solid #fff;
    border-radius: 50%;
    pointer-events: none; /* Prevent cursor from affecting other elements */
    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */
    transform: translate(-50%, -50%);
  }

  .fullscreen_6 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_6 img {
    object-fit: cover;
    object-position: 20% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_7_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A7_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 350px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .Info__7 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__7__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__7__1 p {
    font-size: 18px;
  }

  .Info__7__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Aforismo_8_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A8_1_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .A8_2_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    pointer-events: none;
  }

  .Info__8 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__8__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__8__1 p {
    font-size: 18px;
  }

  .Info__8__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen4 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_9_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Info__9__title {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    color: white;
    position: static;
    max-width: 100%;
    justify-self: center;
    justify-content: left;
    align-items: start;
  }

  .Info_9_title_1 {
    grid-column: 1 / 2;
  }

  .Info_9_title_2 {
    grid-column: 2 / 3;
  }

  .A9_1_Animation {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 150px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A9_2_Animation {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: -1rem;
    color: white;
    height: 150px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__9 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__9__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__9__1 p {
    font-size: 18px;
  }

  .Info__9__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_9 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_9 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_10_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A10_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 30%;
    width: auto;
    z-index: 40;
    display: none;
    justify-self: center;
  }

  .Info__10 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__10__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__10__1 p {
    font-size: 18px;
  }

  .Info__10__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_10 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_10 img {
    object-fit: cover;
    object-position: 65% 50%;
    height: 100%;
    width: 100%;
  }
}

@media all and (min-width: 376px) and (max-width: 425px) {
  /* Mobile L*/

  .Theory {
    display: grid;
    justify-content: center;
    align-items: start;
    margin: 0 auto;
    padding: 0;
    height: 200svh;
    max-width: 89.5%;
    text-align: center;
    padding-top: 19svh;
  }

  .Theory__Caption {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    align-items: start;
    margin: 0 auto;
    width: 89.5%;
    position: sticky;
    bottom: 0;
    left: 0;
  }

  .Theory__Caption p {
    grid-column: 1 / 2;
    color: white;
    font-size: 18px;
    font-weight: normal;
    padding-bottom: 1.5em;
  }

  .Theory__Caption2 {
    display: none;
  }

  .image-container {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    justify-self: center !important;
    transition: transform 0.3s ease, opacity 0.3s ease;
    scroll-behavior: smooth;
    width: min-content;
    margin: 0 auto;
  }

  .rotating-image {
    max-width: 350px; /* Adjusted for better mobile responsiveness */
    height: auto;
    margin: 0 auto;
  }

  .Tecno__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Tecno__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Tecno__Text p {
    justify-self: start;
  }

  .Tecno__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Autor__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Autor__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Autor__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Programa__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Programa__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Programa__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Design__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Design__Text {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: center;
    display: flex;
  }

  .Design__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .NextButton {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 0;
    justify-self: center;
    align-self: center;
    height: auto;
  }

  .Tecno__Section {
    display: none;
  }

  .Autor__Section {
    display: none;
  }

  .Programa__Section {
    display: none;
  }

  .Design__Section {
    display: none;
  }

  .show {
    display: grid;
    z-index: 10;
  }

  /* Aforismos */

  .Theory__Aforismos {
    background-color: black;
    height: 500svh;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Aforismo_1_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    color: white;
    border: 1px solid white;
    min-height: 30%;
    z-index: 2;
    justify-self: left;
    align-self: flex-start;
    margin: 0;
    display: none;
  }

  .Info__1 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: relative;
    top: 0;
    left: 0;
    max-width: 100%;
    align-items: start;
  }

  .Info__1__1 h1 {
    font-size: 20px;
    font-weight: bolder;
    margin: 0;
  }

  .Info__1__1 p {
    font-size: 20px;
  }

  .Info__1__2 p {
    font-size: 20px;
    margin: 0;
  }

  .fullscreen_1 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_1 img {
    object-fit: cover;
    object-position: 50% 80%;
    height: 100%;
    width: 100%;
  }

  .BG_info {
    position: fixed;
    left: 5%;
    bottom: 5%;
    color: white;
  }

  .BG_info h1 {
    font-size: 18px;
    font-weight: bolder;
    line-height: 1em;
  }

  .BG_info p {
    font-size: 18px;
  }

  .Aforismo_2_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 87.75svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A2_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: fixed;
    top: -1.5rem;
    left: -3.6rem;
    color: white;
    height: 290px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
    align-self: self-start;
  }

  .Info__2 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: fixed;
    top: 15.4rem;
    left: 2.4rem;
    max-width: 90%;
    align-items: start;
  }

  .Info__2__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__2__1 p {
    font-size: 18px;
  }

  .Info__2__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_2 img {
    object-fit: cover;
    object-position: 55% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_3_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line2 {
    position: fixed;
    top: 0;
    left: 10%;
    color: white;
    border-left: 20px solid white;
    min-height: 605px;
    z-index: 2;
    display: none;
  }

  .A3_Animation {
    position: fixed;
    bottom: 100%;
    left: 15%;
    color: white;
    height: 190px;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__3 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
  }

  .Info__3__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__3__1 p {
    font-size: 18px;
  }

  .Info__3__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen2 {
    height: 90%;
    width: 89.5%;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 5.25%;
  }

  .fullscreen2 img {
    object-fit: contain;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_4_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A4_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 5rem;
    left: 0;
    color: white;
    height: auto;
    width: 100%;
    z-index: 2;
    display: none;
    align-self: self-start;
    justify-self: center;
  }

  .Info__4 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__4__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__4__1 p {
    font-size: 18px;
  }

  .Info__4__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_4 img {
    object-fit: cover;
    object-position: 52.5% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_5_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Aforismo_5_Animation_Grid {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    display: grid;
    gap: 0;
    grid-template-columns: 1fr 1fr;
    color: white;
    position: static;
    width: 100%;
  }

  .A5_1_Animation {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    justify-self: end;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
  }

  .A5_2_Animation {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__5 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__5__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__5__1 p {
    font-size: 18px;
  }

  .Info__5__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen3 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen3 img {
    object-fit: scale-down;
    height: 100%;
    width: 100%;
  }

  .Aforismo_6_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Info__6 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__6__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__6__1 p {
    font-size: 18px;
  }

  .Info__6__2 p {
    font-size: 18px;
    margin: 0;
  }

  /* src/MouseParallax.css */
  .mouse-parallax-container {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .background-blurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: blur(2px); /* Add a blur effect to the background */
  }

  .background-unblurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: none; /* No blur effect on the unblurred content */
  }

  .mouse-cursor {
    position: absolute;
    width: 100px;
    height: 100px;
    border: 2px solid #fff;
    border-radius: 50%;
    pointer-events: none; /* Prevent cursor from affecting other elements */
    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */
    transform: translate(-50%, -50%);
  }

  .fullscreen_6 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_6 img {
    object-fit: cover;
    object-position: 30% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_7_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A7_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 350px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .Info__7 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__7__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__7__1 p {
    font-size: 18px;
  }

  .Info__7__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Aforismo_8_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A8_1_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .A8_2_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 250px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    pointer-events: none;
  }

  .Info__8 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__8__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__8__1 p {
    font-size: 18px;
  }

  .Info__8__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen4 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_9_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Info__9__title {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    color: white;
    position: static;
    max-width: 100%;
    justify-self: center;
    justify-content: left;
    align-items: start;
  }

  .Info_9_title_1 {
    grid-column: 1 / 2;
  }

  .Info_9_title_2 {
    grid-column: 2 / 3;
  }

  .A9_1_Animation {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 150px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A9_2_Animation {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: -1rem;
    color: white;
    height: 150px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__9 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__9__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__9__1 p {
    font-size: 18px;
  }

  .Info__9__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_9 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_9 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_10_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A10_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 25%;
    width: auto;
    z-index: 40;
    display: none;
    justify-self: center;
  }

  .Info__10 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__10__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__10__1 p {
    font-size: 18px;
  }

  .Info__10__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_10 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_10 img {
    object-fit: cover;
    object-position: 62.5% 50%;
    height: 100%;
    width: 100%;
  }

  .BG_info {
    position: fixed;
    left: 5%;
    bottom: 2.5%;
    color: white;
  }

  .BG_info h1 {
    font-size: 18px;
    font-weight: bolder;
    line-height: 1em;
  }

  .BG_info p {
    font-size: 18px;
  }
}

@media all and (min-width: 321px) and (max-width: 375px) {
  /* Mobile M */

  .Theory {
    display: grid;
    justify-content: center;
    align-items: start;
    margin: 0 auto;
    padding: 0;
    height: 200svh;
    max-width: 89.5%;
    text-align: center;
    padding-top: 21svh;
  }

  .Theory__Caption {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    align-items: start;
    margin: 0 auto;
    width: 89.5%;
    position: sticky;
    bottom: 0;
    left: 0;
  }

  .Theory__Caption p {
    grid-column: 1 / 2;
    color: white;
    font-size: 18px;
    font-weight: normal;
    padding-bottom: 1.5em;
  }

  .Theory__Caption2 {
    display: none;
  }

  .image-container {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    justify-self: center !important;
    transition: transform 0.3s ease, opacity 0.3s ease;
    scroll-behavior: smooth;
    width: min-content;
    margin: 0 auto;
  }

  .rotating-image {
    max-width: 300px; /* Adjusted for better mobile responsiveness */
    height: auto;
    margin: 0 auto;
  }

  .Tecno__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Tecno__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Tecno__Text p {
    justify-self: start;
  }

  .Tecno__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Autor__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Autor__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Autor__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Programa__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Programa__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Programa__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Design__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Design__Text {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: center;
    display: flex;
  }

  .Design__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .NextButton {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 0;
    justify-self: center;
    align-self: center;
    height: auto;
  }

  .Tecno__Section {
    display: none;
  }

  .Autor__Section {
    display: none;
  }

  .Programa__Section {
    display: none;
  }

  .Design__Section {
    display: none;
  }

  .show {
    display: grid;
    z-index: 10;
  }

  /* Aforismos */

  .Theory__Aforismos {
    background-color: black;
    height: 500svh;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Aforismo_1_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    color: white;
    border: 1px solid white;
    min-height: 30%;
    z-index: 2;
    justify-self: left;
    align-self: flex-start;
    margin: 0;
    display: none;
  }

  .Info__1 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: relative;
    top: 0;
    left: 0;
    max-width: 100%;
    align-items: start;
  }

  .Info__1__1 h1 {
    font-size: 20px;
    font-weight: bolder;
    margin: 0;
  }

  .Info__1__1 p {
    font-size: 20px;
  }

  .Info__1__2 p {
    font-size: 20px;
    margin: 0;
  }

  .fullscreen_1 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_1 img {
    object-fit: cover;
    object-position: 65% 80%;
    height: 100%;
    width: 100%;
  }

  .BG_info {
    position: fixed;
    left: 5%;
    bottom: 5%;
    color: white;
  }

  .BG_info h1 {
    font-size: 18px;
    font-weight: bolder;
    line-height: 1em;
  }

  .BG_info p {
    font-size: 18px;
  }

  .Aforismo_2_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 87.75svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A2_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: fixed;
    top: -1.5rem;
    left: -3.6rem;
    color: white;
    height: 290px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
    align-self: self-start;
  }

  .Info__2 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: fixed;
    top: 15.4rem;
    left: 2.4rem;
    max-width: 80%;
    align-items: start;
  }

  .Info__2__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__2__1 p {
    font-size: 18px;
  }

  .Info__2__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_2 img {
    object-fit: cover;
    object-position: 55% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_3_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line2 {
    position: fixed;
    top: 0;
    left: 10%;
    color: white;
    border-left: 20px solid white;
    min-height: 605px;
    z-index: 2;
    display: none;
  }

  .A3_Animation {
    position: fixed;
    bottom: 100%;
    left: 15%;
    color: white;
    height: 190px;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__3 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
  }

  .Info__3__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__3__1 p {
    font-size: 18px;
  }

  .Info__3__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen2 img {
    object-fit: contain;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_4_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A4_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 5rem;
    left: 0;
    color: white;
    height: auto;
    width: 100%;
    z-index: 2;
    display: none;
    align-self: self-start;
    justify-self: center;
  }

  .Info__4 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__4__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__4__1 p {
    font-size: 18px;
  }

  .Info__4__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_4 img {
    object-fit: cover;
    object-position: 52.5% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_5_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Aforismo_5_Animation_Grid {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    display: grid;
    gap: 0;
    grid-template-columns: 1fr 1fr;
    color: white;
    position: static;
    width: 100%;
  }

  .A5_1_Animation {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    justify-self: end;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
  }

  .A5_2_Animation {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__5 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__5__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__5__1 p {
    font-size: 18px;
  }

  .Info__5__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen3 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen3 img {
    object-fit: scale-down;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_6_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Info__6 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__6__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__6__1 p {
    font-size: 18px;
  }

  .Info__6__2 p {
    font-size: 18px;
    margin: 0;
  }

  /* src/MouseParallax.css */
  .mouse-parallax-container {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .background-blurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: blur(2px); /* Add a blur effect to the background */
  }

  .background-unblurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: none; /* No blur effect on the unblurred content */
  }

  .mouse-cursor {
    position: absolute;
    width: 100px;
    height: 100px;
    border: 2px solid #fff;
    border-radius: 50%;
    pointer-events: none; /* Prevent cursor from affecting other elements */
    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */
    transform: translate(-50%, -50%);
  }

  .fullscreen_6 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_6 img {
    object-fit: cover;
    object-position: 30% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_7_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A7_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 300px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .Info__7 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__7__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__7__1 p {
    font-size: 18px;
  }

  .Info__7__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Aforismo_8_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A8_1_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 200px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .A8_2_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 200px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    pointer-events: none;
  }

  .Info__8 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__8__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__8__1 p {
    font-size: 18px;
  }

  .Info__8__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen4 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_9_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Info__9__title {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    color: white;
    position: static;
    max-width: 100%;
    justify-self: center;
    justify-content: left;
    align-items: start;
  }

  .Info_9_title_1 {
    grid-column: 1 / 2;
  }

  .Info_9_title_2 {
    grid-column: 2 / 3;
  }

  .A9_1_Animation {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 150px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A9_2_Animation {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: -1rem;
    color: white;
    height: 150px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__9 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__9__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__9__1 p {
    font-size: 18px;
  }

  .Info__9__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_9 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_9 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_10_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A10_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 20%;
    width: auto;
    z-index: 40;
    display: none;
    justify-self: center;
  }

  .Info__10 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__10__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__10__1 p {
    font-size: 18px;
  }

  .Info__10__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_10 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_10 img {
    object-fit: cover;
    object-position: 62.5% 50%;
    height: 100%;
    width: 100%;
  }
}

@media all and (max-width: 320px) {
  /* Mobile S*/

  .Theory {
    display: grid;
    justify-content: center;
    align-items: start;
    margin: 0 auto;
    padding: 0;
    height: 200svh;
    max-width: 89.5%;
    text-align: center;
    padding-top: 23svh;
  }

  .Theory__Caption {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    align-items: start;
    margin: 0 auto;
    width: 89.5%;
    position: sticky;
    bottom: 0;
    left: 0;
  }

  .Theory__Caption p {
    grid-column: 1 / 2;
    color: white;
    font-size: 18px;
    font-weight: normal;
    padding-bottom: 1.5em;
  }

  .Theory__Caption2 {
    display: none;
  }

  .image-container {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    justify-self: center !important;
    transition: transform 0.3s ease, opacity 0.3s ease;
    scroll-behavior: smooth;
    width: min-content;
    margin: 0 auto;
  }

  .rotating-image {
    max-width: 250px; /* Adjusted for better mobile responsiveness */
    height: auto;
    margin: 0 auto;
  }

  .Tecno__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Tecno__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Tecno__Text p {
    justify-self: start;
  }

  .Tecno__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Autor__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Autor__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Autor__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Programa__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Programa__Text {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: start;
    display: flex;
  }

  .Programa__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Design__Section {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0;
    top: 0;
    height: 100svh;
    width: 89%;
    justify-content: center;
  }

  .Design__Text {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    color: white;
    font-size: 18px;
    width: 100%;
    position: static;
    justify-self: center;
    align-items: center;
    height: auto;
    align-self: center;
    display: flex;
  }

  .Design__Button {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 25px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .NextButton {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    color: white;
    font-size: 18px;
    font-weight: bold;
    opacity: 60%;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    position: relative;
    bottom: 125px;
    justify-self: center;
    align-self: self-end;
    height: auto;
  }

  .Tecno__Section {
    display: none;
  }

  .Autor__Section {
    display: none;
  }

  .Programa__Section {
    display: none;
  }

  .Design__Section {
    display: none;
  }

  .show {
    display: grid;
    z-index: 10;
  }

  /* Aforismos */

  .Theory__Aforismos {
    background-color: black;
    height: 500svh;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Aforismo_1_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    color: white;
    border: 1px solid white;
    min-height: 30%;
    z-index: 2;
    justify-self: left;
    align-self: flex-start;
    margin: 0;
    display: none;
  }

  .Info__1 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: relative;
    top: 1rem;
    left: 0;
    max-width: 100%;
    align-items: start;
  }

  .Info__1__1 h1 {
    font-size: 20px;
    font-weight: bolder;
    margin: 0;
  }

  .Info__1__1 p {
    font-size: 20px;
  }

  .Info__1__2 p {
    font-size: 20px;
    margin: 0;
  }

  .fullscreen_1 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_1 img {
    object-fit: cover;
    object-position: 65% 80%;
    height: 100%;
    width: 100%;
  }

  .BG_info {
    position: fixed;
    left: 5%;
    bottom: 5%;
    color: white;
  }

  .BG_info h1 {
    font-size: 18px;
    font-weight: bolder;
    line-height: 1em;
  }

  .BG_info p {
    font-size: 18px;
  }

  .Aforismo_2_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 87.75svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A2_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: fixed;
    top: -1.5rem;
    left: -3.6rem;
    color: white;
    height: 290px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
    align-self: self-start;
  }

  .Info__2 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: fixed;
    top: 15.4rem;
    left: 2.4rem;
    max-width: 80%;
    align-items: start;
  }

  .Info__2__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__2__1 p {
    font-size: 18px;
  }

  .Info__2__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_2 img {
    object-fit: cover;
    object-position: 55% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_3_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .line2 {
    position: fixed;
    top: 0;
    left: 10%;
    color: white;
    border-left: 20px solid white;
    min-height: 605px;
    z-index: 2;
    display: none;
  }

  .A3_Animation {
    position: fixed;
    bottom: 100%;
    left: 15%;
    color: white;
    height: 190px;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__3 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
  }

  .Info__3__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__3__1 p {
    font-size: 18px;
  }

  .Info__3__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen2 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen2 img {
    object-fit: contain;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_4_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A4_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 5rem;
    left: 0;
    color: white;
    height: auto;
    width: 100%;
    z-index: 2;
    display: none;
    align-self: self-start;
    justify-self: center;
  }

  .Info__4 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__4__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__4__1 p {
    font-size: 18px;
  }

  .Info__4__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_4 img {
    object-fit: cover;
    object-position: 52.5% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_5_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Aforismo_5_Animation_Grid {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    display: grid;
    gap: 0;
    grid-template-columns: 1fr 1fr;
    color: white;
    position: static;
    width: 100%;
  }

  .A5_1_Animation {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    justify-self: end;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
  }

  .A5_2_Animation {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    position: static;
    justify-self: start;
    color: white;
    height: 100%;
    width: auto;
    z-index: 2;
    display: none;
  }

  .Info__5 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__5__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__5__1 p {
    font-size: 18px;
  }

  .Info__5__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen3 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen3 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_6_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Info__6 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__6__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__6__1 p {
    font-size: 18px;
  }

  .Info__6__2 p {
    font-size: 18px;
    margin: 0;
  }

  /* src/MouseParallax.css */
  .mouse-parallax-container {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .background-blurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: blur(2px); /* Add a blur effect to the background */
  }

  .background-unblurred {
    position: fixed;
    width: 100%;
    height: 100%;
    filter: none; /* No blur effect on the unblurred content */
  }

  .mouse-cursor {
    position: absolute;
    width: 100px;
    height: 100px;
    border: 2px solid #fff;
    border-radius: 50%;
    pointer-events: none; /* Prevent cursor from affecting other elements */
    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */
    transform: translate(-50%, -50%);
  }

  .fullscreen_6 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_6 img {
    object-fit: cover;
    object-position: 30% 50%;
    height: 100%;
    width: 100%;
  }

  .Aforismo_7_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A7_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 300px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .Info__7 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__7__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__7__1 p {
    font-size: 18px;
  }

  .Info__7__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Aforismo_8_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A8_1_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 200px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .A8_2_Animation {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 200px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: center;
  }

  .cursor {
    background-color: #ffffff;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    pointer-events: none;
  }

  .Info__8 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__8__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__8__1 p {
    font-size: 18px;
  }

  .Info__8__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen4 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen4 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_9_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .Info__9__title {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    color: white;
    position: static;
    max-width: 100%;
    justify-self: center;
    justify-content: left;
    align-items: start;
  }

  .Info_9_title_1 {
    grid-column: 1 / 2;
    font-size: 16px;
  }

  .Info_9_title_2 {
    grid-column: 2 / 3;
    font-size: 16px;
  }

  .A9_1_Animation {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 150px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: right;
  }

  .A9_2_Animation {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    position: relative;
    top: 0;
    left: -1rem;
    color: white;
    height: 150px;
    width: auto;
    z-index: 2;
    display: none;
    justify-self: left;
  }

  .Info__9 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__9__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__9__1 p {
    font-size: 18px;
  }

  .Info__9__2 p {
    font-size: 18px;
    margin: 0;
  }

  .Info_9_title_1 {
    font-size: 16px !important;
  }

  .Info_9_title_2 {
    font-size: 16px !important;
  }

  .fullscreen_9 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_9 img {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }

  .Aforismo_10_Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    color: white;
    height: 100svh;
    position: fixed;
    margin: 0 auto;
    left: 5.25%;
    top: 0;
    max-width: 89.5%;
    width: 100%;
    justify-items: left;
    align-items: center;
  }

  .A10_Animation {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    position: static;
    color: white;
    height: 20%;
    width: auto;
    z-index: 40;
    display: none;
    justify-self: center;
  }

  .Info__10 {
    display: grid;
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    grid-template-rows: 1fr;
    gap: 1rem;
    color: white;
    position: static;
    max-width: 100%;
    align-items: start;
    justify-self: start;
  }

  .Info__10__1 h1 {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
  }

  .Info__10__1 p {
    font-size: 18px;
  }

  .Info__10__2 p {
    font-size: 18px;
    margin: 0;
  }

  .fullscreen_10 {
    height: 100svh;
    width: 100vw;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
  }

  .fullscreen_10 img {
    object-fit: cover;
    object-position: 62.5% 50%;
    height: 100%;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Theory.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,iDAAiD;EACtE,uBAAuB;EACvB,kDAAkD;EAClD,uBAAuB;EACvB,UAAU,EAAE,8CAA8C;EAC1D,cAAc;AAChB;;AAEA;EACE,gBAAgB,EAAE,8CAA8C;EAChE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,SAAS;EACT,WAAW;EACX,yBAAyB;EAIzB,wBAAwB;AAH1B;AAKA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,QAAQ;EACR,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,QAAQ;EACR,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,QAAQ;EACR,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,QAAQ;EACR,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,OAAO;EACP,MAAM;EACN,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,QAAQ;IACR,QAAQ;IACR,iBAAiB;IACjB,UAAU;IACV,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,QAAQ;IACR,QAAQ;IACR,iBAAiB;IACjB,UAAU;IACV,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,QAAQ;IACR,QAAQ;IACR,iBAAiB;IACjB,UAAU;IACV,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA,cAAc;;EAEd;IACE,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,aAAa;IACb,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,OAAO;IACP,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,MAAM;IACN,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,wCAAwC;EAC7D;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY,EAAE,4CAA4C;EAC5D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB,EAAE,iDAAiD;IACvE,yBAAyB,EAAE,yCAAyC;IACpE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,WAAW;IACX,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,OAAO;IACP,MAAM;IACN,cAAc;IACd,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;;EAEd;IACE,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,OAAO;IACP,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,MAAM;IACN,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,wCAAwC;EAC7D;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY,EAAE,4CAA4C;EAC5D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB,EAAE,iDAAiD;IACvE,yBAAyB,EAAE,yCAAyC;IACpE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,WAAW;IACX,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,OAAO;IACP,MAAM;IACN,cAAc;IACd,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;;EAEb,cAAc;;EAEd;IACE,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,aAAa;IACb,eAAe;IACf,cAAc;IACd,SAAS;IACT,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,OAAO;IACP,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,MAAM;IACN,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,wCAAwC;EAC7D;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY,EAAE,4CAA4C;EAC5D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB,EAAE,iDAAiD;IACvE,yBAAyB,EAAE,yCAAyC;IACpE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,aAAa;IACb,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,SAAS;IACT,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,WAAW;IACX,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,OAAO;IACP,MAAM;IACN,cAAc;IACd,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,wBAAwB;;EAExB;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;IAC/B,kDAAkD;IAClD,uBAAuB;IACvB,uBAAkB;IAAlB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA,cAAc;;EAEd;IACE,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,aAAa;IACb,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,UAAU;IACV,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,MAAM;IACN,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,wCAAwC;EAC7D;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY,EAAE,4CAA4C;EAC5D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB,EAAE,iDAAiD;IACvE,yBAAyB,EAAE,yCAAyC;IACpE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;IACX,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,OAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;IAC/B,kDAAkD;IAClD,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;IAChE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,cAAc;IACd,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,SAAS;;EAET;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kBAAkB;EACpB;;EAEA,cAAc;;EAEd;IACE,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,MAAM;IACN,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,wCAAwC;EAC7D;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY,EAAE,4CAA4C;EAC5D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB,EAAE,iDAAiD;IACvE,yBAAyB,EAAE,yCAAyC;IACpE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,WAAW;IACX,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,YAAY;;EAEZ;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,OAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;IAC/B,kDAAkD;IAClD,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;IAChE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA,cAAc;;EAEd;IACE,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,MAAM;IACN,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,wCAAwC;EAC7D;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY,EAAE,4CAA4C;EAC5D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB,EAAE,iDAAiD;IACvE,yBAAyB,EAAE,yCAAyC;IACpE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,WAAW;IACX,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;;EAEb;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,OAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;IAC/B,kDAAkD;IAClD,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;IAChE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA,cAAc;;EAEd;IACE,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,MAAM;IACN,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,wCAAwC;EAC7D;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY,EAAE,4CAA4C;EAC5D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB,EAAE,iDAAiD;IACvE,yBAAyB,EAAE,yCAAyC;IACpE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,WAAW;IACX,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,YAAY;;EAEZ;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,OAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;IAC/B,kDAAkD;IAClD,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;IAChE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;IACX,MAAM;IACN,cAAc;IACd,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA,cAAc;;EAEd;IACE,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,MAAM;IACN,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,wCAAwC;EAC7D;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY,EAAE,4CAA4C;EAC5D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB,EAAE,iDAAiD;IACvE,yBAAyB,EAAE,yCAAyC;IACpE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;IACX,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,WAAW;IACX,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".Theory {\r\n  display: grid;\r\n  justify-content: center;\r\n  align-items: start;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  height: 180svh;\r\n  max-width: 68.6%;\r\n  text-align: center;\r\n}\r\n\r\n.Theory__Caption {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  align-items: start;\r\n  position: sticky;\r\n  bottom: 0;\r\n  left: 0;\r\n}\r\n\r\n.Theory__Caption p {\r\n  grid-column: 3 / 4;\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n  padding-bottom: 1.5em;\r\n}\r\n\r\n.Theory__Caption2 {\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n  position: fixed;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  right: 10svh;\r\n}\r\n\r\n.image-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center; /* Change to center for better mobile alignment */\r\n  justify-content: center;\r\n  transition: transform 0.3s ease, opacity 0.3s ease;\r\n  scroll-behavior: smooth;\r\n  width: 70%; /* Adjusted for better mobile responsiveness */\r\n  margin: 0 auto;\r\n}\r\n\r\n.rotating-image {\r\n  max-width: 800px; /* Adjusted for better mobile responsiveness */\r\n  height: auto;\r\n  margin: 0 auto;\r\n}\r\n\r\n.Theory_Brief {\r\n  height: 120svh;\r\n  padding: 0;\r\n  margin: 0;\r\n  width: 100%;\r\n  overflow: auto !important;\r\n}\r\n\r\n.Theory_Brief {\r\n  -ms-overflow-style: none;\r\n}\r\n.Theory_Brief::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.Triangle_main_mobile {\r\n  display: flex !important;\r\n  max-width: 100vw;\r\n  height: 100svh;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.FixImages {\r\n  height: 110svh !important;\r\n  max-width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-left: 1em;\r\n  margin-right: 1em;\r\n}\r\n\r\n.Tecno__Section {\r\n  position: absolute;\r\n  display: \"grid\";\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 1em;\r\n  top: 50%;\r\n  /* height: 55%; */\r\n  width: 80%;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.Tecno__Text {\r\n  color: white;\r\n  font-size: 18px;\r\n  width: 70%;\r\n  height: 95px;\r\n  position: static;\r\n  justify-self: center;\r\n  align-self: flex-end;\r\n  height: 25svh;\r\n  display: flex;\r\n}\r\n\r\n.Tecno__Text p {\r\n  align-self: flex-end;\r\n}\r\n\r\n.Tecno__Button {\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  opacity: 60%;\r\n  cursor: pointer;\r\n  outline: none;\r\n  box-shadow: none;\r\n  position: static;\r\n  justify-self: left;\r\n  align-self: flex-start;\r\n}\r\n\r\n.Autor__Section {\r\n  position: absolute;\r\n  display: \"grid\";\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 1em;\r\n  top: 50%;\r\n  /* height: 55%; */\r\n  width: 80%;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.Autor__Text {\r\n  color: white;\r\n  font-size: 18px;\r\n  width: 70%;\r\n  height: 95px;\r\n  position: static;\r\n  justify-self: center;\r\n  align-self: flex-end;\r\n  height: 25svh;\r\n  display: flex;\r\n}\r\n\r\n.Autor__Text p {\r\n  align-self: flex-end;\r\n}\r\n\r\n.Autor__Button {\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  opacity: 60%;\r\n  cursor: pointer;\r\n  outline: none;\r\n  box-shadow: none;\r\n  position: static;\r\n  justify-self: left;\r\n  align-self: flex-start;\r\n}\r\n\r\n.Programa__Section {\r\n  position: absolute;\r\n  display: \"grid\";\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 1em;\r\n  top: 50%;\r\n  /* height: 55%; */\r\n  width: 80%;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.Programa__Text {\r\n  color: white;\r\n  font-size: 18px;\r\n  width: 70%;\r\n  height: 95px;\r\n  position: static;\r\n  justify-self: left;\r\n  align-self: flex-end;\r\n  height: 32.5svh;\r\n  display: flex;\r\n}\r\n\r\n.Programa__Text p {\r\n  align-self: flex-end;\r\n}\r\n\r\n.Programa__Button {\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  opacity: 60%;\r\n  cursor: pointer;\r\n  outline: none;\r\n  box-shadow: none;\r\n  position: static;\r\n  justify-self: left;\r\n  align-self: flex-start;\r\n}\r\n\r\n.Design__Section {\r\n  position: absolute;\r\n  display: \"grid\";\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  gap: 1em;\r\n  top: 50%;\r\n  /* height: 55%; */\r\n  width: 80%;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.Design__Text {\r\n  color: white;\r\n  font-size: 18px;\r\n  width: 95%;\r\n  height: 95px;\r\n  position: static;\r\n  justify-self: left;\r\n  align-self: flex-start;\r\n  height: 32.5svh;\r\n  display: flex;\r\n  grid-column: 3 / 4;\r\n}\r\n\r\n.Design__Button {\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  opacity: 60%;\r\n  cursor: pointer;\r\n  outline: none;\r\n  box-shadow: none;\r\n  position: static;\r\n  justify-self: left;\r\n  align-self: flex-start;\r\n}\r\n\r\n.NextButton {\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  opacity: 60%;\r\n  cursor: pointer;\r\n  outline: none;\r\n  box-shadow: none;\r\n  position: static;\r\n  justify-self: right;\r\n  align-self: flex-start;\r\n}\r\n\r\n.Tecno__Section {\r\n  display: none;\r\n}\r\n\r\n.Autor__Section {\r\n  display: none;\r\n}\r\n\r\n.Programa__Section {\r\n  display: none;\r\n}\r\n\r\n.Design__Section {\r\n  display: none;\r\n}\r\n\r\n.show {\r\n  display: grid;\r\n  z-index: 10;\r\n}\r\n\r\n.workplz {\r\n  max-height: 100svh !important;\r\n  max-width: 100vw !important;\r\n  width: 90%;\r\n  height: auto;\r\n}\r\n\r\n.Main {\r\n  padding: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100svh;\r\n  width: 100vw;\r\n}\r\n\r\n.fixedNav {\r\n  position: relative;\r\n  height: min-content;\r\n}\r\n\r\n.false {\r\n  cursor: pointer;\r\n}\r\n\r\n.hidden {\r\n  display: none;\r\n}\r\n\r\n.endAforismos {\r\n  display: grid;\r\n  color: white;\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  height: 100svh;\r\n  width: 100vw;\r\n  justify-content: center !important;\r\n  align-items: center;\r\n}\r\n\r\n@media all and (min-width: 1921px) {\r\n  .Autor__Section {\r\n    position: absolute;\r\n    display: \"grid\";\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 1em;\r\n    top: 50%;\r\n    /* height: 55%; */\r\n    width: 80%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Autor__Text {\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 70%;\r\n    height: 95px;\r\n    position: static;\r\n    justify-self: center;\r\n    align-self: flex-end;\r\n    height: 25svh;\r\n    display: flex;\r\n  }\r\n\r\n  .Autor__Text p {\r\n    align-self: flex-end;\r\n  }\r\n\r\n  .Autor__Button {\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: static;\r\n    justify-self: left;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .Programa__Section {\r\n    position: absolute;\r\n    display: \"grid\";\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 1em;\r\n    top: 50%;\r\n    /* height: 55%; */\r\n    width: 80%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Programa__Text {\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 70%;\r\n    height: 95px;\r\n    position: static;\r\n    justify-self: left;\r\n    align-self: flex-end;\r\n    height: 32.5svh;\r\n    display: flex;\r\n  }\r\n\r\n  .Programa__Text p {\r\n    align-self: flex-end;\r\n  }\r\n\r\n  .Programa__Button {\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: static;\r\n    justify-self: left;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .Design__Section {\r\n    position: absolute;\r\n    display: \"grid\";\r\n    grid-template-columns: 1fr 1fr 1fr 1fr;\r\n    gap: 1em;\r\n    top: 50%;\r\n    /* height: 55%; */\r\n    width: 80%;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Design__Text {\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 95%;\r\n    height: 95px;\r\n    position: static;\r\n    justify-self: left;\r\n    align-self: flex-start;\r\n    height: 32.5svh;\r\n    display: flex;\r\n    grid-column: 3 / 4;\r\n  }\r\n\r\n  .Design__Button {\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: static;\r\n    justify-self: left;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .NextButton {\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: static;\r\n    justify-self: right;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  /* Aforismos */\r\n\r\n  .Theory__Aforismos {\r\n    background-color: black;\r\n    height: auto;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: block;\r\n  }\r\n\r\n  .Aforismo_1_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .line {\r\n    grid-column: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    border-left: 1px solid white;\r\n    min-height: 50%;\r\n    z-index: 2;\r\n    justify-self: right;\r\n    align-self: flex-start;\r\n    margin: 0;\r\n    display: none;\r\n  }\r\n\r\n  .Info__1 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: relative;\r\n    top: 10%;\r\n    left: -2.5%;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__1__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__1__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__1__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_1 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_1 img {\r\n    object-fit: cover;\r\n    object-position: 50% 70%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_2_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 80svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n  }\r\n\r\n  .A2_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 2.5rem;\r\n    left: 3.8rem;\r\n    color: white;\r\n    height: 290px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n  }\r\n\r\n  .Info__2 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 2 / 3;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__2__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__2__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__2__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_2 img {\r\n    object-fit: cover;\r\n    object-position: 50% 45%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .line2 {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 41%;\r\n    color: white;\r\n    border-left: 20px solid white;\r\n    min-height: 605px;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .fullscreen2 {\r\n    height: 75svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 12.5%;\r\n    left: 0;\r\n    padding-left: 2.5vw;\r\n    padding-right: 2.5vw;\r\n  }\r\n\r\n  .fullscreen2 img {\r\n    object-fit: contain;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_3_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .A3_Animation {\r\n    position: fixed;\r\n    bottom: 100%;\r\n    left: 45%;\r\n    color: white;\r\n    height: 190px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__3 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__3__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__3__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__3__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo_4_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .A4_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 5rem;\r\n    left: 0;\r\n    color: white;\r\n    height: auto;\r\n    width: 100%;\r\n    z-index: 2;\r\n    display: none;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Info__4 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__4__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__4__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__4__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_4 img {\r\n    object-fit: cover;\r\n    object-position: 50% 100%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_5_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_5_Animation_Grid {\r\n    grid-column: 3 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    gap: 0;\r\n    grid-template-columns: 1fr 1fr;\r\n    color: white;\r\n    position: static;\r\n  }\r\n\r\n  .A5_1_Animation {\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A5_2_Animation {\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__5 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__5__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__5__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__5__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen3 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen3 img {\r\n    object-fit: scale-down;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_6_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__6 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__6__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__6__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__6__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  /* src/MouseParallax.css */\r\n  .mouse-parallax-container {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .background-blurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: blur(2px); /* Add a blur effect to the background */\r\n  }\r\n\r\n  .background-unblurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: none; /* No blur effect on the unblurred content */\r\n  }\r\n\r\n  .mouse-cursor {\r\n    position: absolute;\r\n    width: 100px;\r\n    height: 100px;\r\n    border: 2px solid #fff;\r\n    border-radius: 50%;\r\n    pointer-events: none; /* Prevent cursor from affecting other elements */\r\n    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  .fullscreen_6 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_6 img {\r\n    object-fit: cover;\r\n    object-position: 50% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_7_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .A7_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 500px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__7 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__7__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__7__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__7__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo_8_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .A8_1_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .A8_2_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 50%;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    display: none;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .Info__8 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__8__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__8__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__8__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen4 img {\r\n    object-fit: cover;\r\n    object-position: 50% 30%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_9_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Info__9__title {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    justify-self: center;\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info_9_title_1 {\r\n    grid-column: 1 / 2;\r\n  }\r\n\r\n  .Info_9_title_2 {\r\n    grid-column: 2 / 3;\r\n  }\r\n\r\n  .A9_1_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A9_2_Animation {\r\n    grid-column: 3 / 5;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: -3svh;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__9 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__9__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__9__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__9__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_9 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_9 img {\r\n    object-fit: cover;\r\n    object-position: 50% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_10_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .A10_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: auto;\r\n    width: 60%;\r\n    z-index: 40;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__10 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__10__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__10__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__10__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_10 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_10 img {\r\n    object-fit: cover;\r\n    object-position: 50% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .endAforismos {\r\n    display: grid;\r\n    color: white;\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 100vw;\r\n    justify-content: center !important;\r\n    align-items: center;\r\n  }\r\n\r\n  .BG_info {\r\n    position: fixed;\r\n    left: 15.7%;\r\n    bottom: 10%;\r\n    color: white;\r\n  }\r\n\r\n  .BG_info h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    line-height: 1em;\r\n  }\r\n\r\n  .BG_info p {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1441px) and (max-width: 1920px) {\r\n  /* Aforismos */\r\n\r\n  .Theory__Aforismos {\r\n    background-color: black;\r\n    height: 500svh;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_1_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center !important;\r\n  }\r\n\r\n  .line {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    left: 20px;\r\n    color: white;\r\n    border-left: 1px solid white;\r\n    min-height: 45%;\r\n    z-index: 2;\r\n    justify-self: right;\r\n    align-self: flex-start;\r\n    margin: 0;\r\n    display: none;\r\n  }\r\n\r\n  .Info__1 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__1__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__1__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__1__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_1 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_1 img {\r\n    object-fit: cover;\r\n    object-position: 50% 60%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_2_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .A2_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: -10.35rem;\r\n    left: 3.8rem;\r\n    color: white;\r\n    height: 290px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .Info__2 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__2__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__2__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__2__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_2 img {\r\n    object-fit: cover;\r\n    object-position: 50% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .line2 {\r\n    position: relative;\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    color: white;\r\n    border-left: 20px solid white;\r\n    min-height: 605px;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n    align-self: flex-end;\r\n  }\r\n\r\n  .fullscreen2 {\r\n    height: 75svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 12.5%;\r\n    left: 0;\r\n    padding-left: 2.5vw;\r\n    padding-right: 2.5vw;\r\n  }\r\n\r\n  .fullscreen2 img {\r\n    object-fit: contain;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_3_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .A3_Animation {\r\n    position: relative;\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 /2;\r\n    color: white;\r\n    height: 190px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n    align-self: start;\r\n  }\r\n\r\n  .Info__3 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 /2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__3__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__3__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__3__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo_4_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .A4_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 5rem;\r\n    left: 0;\r\n    color: white;\r\n    height: auto;\r\n    width: 100%;\r\n    z-index: 2;\r\n    display: none;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Info__4 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__4__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__4__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__4__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_4 img {\r\n    object-fit: cover;\r\n    object-position: 50% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_5_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_5_Animation_Grid {\r\n    grid-column: 3 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    gap: 0;\r\n    grid-template-columns: 1fr 1fr;\r\n    color: white;\r\n    position: static;\r\n  }\r\n\r\n  .A5_1_Animation {\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A5_2_Animation {\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__5 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__5__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__5__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__5__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen3 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen3 img {\r\n    object-fit: scale-down;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_6_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__6 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__6__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__6__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__6__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  /* src/MouseParallax.css */\r\n  .mouse-parallax-container {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .background-blurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: blur(2px); /* Add a blur effect to the background */\r\n  }\r\n\r\n  .background-unblurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: none; /* No blur effect on the unblurred content */\r\n  }\r\n\r\n  .mouse-cursor {\r\n    position: absolute;\r\n    width: 100px;\r\n    height: 100px;\r\n    border: 2px solid #fff;\r\n    border-radius: 50%;\r\n    pointer-events: none; /* Prevent cursor from affecting other elements */\r\n    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  .fullscreen_6 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_6 img {\r\n    object-fit: cover;\r\n    object-position: 50% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_7_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .A7_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 500px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__7 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__7__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__7__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__7__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo_8_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 500;\r\n  }\r\n\r\n  .A8_1_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 30%;\r\n    width: auto;\r\n    display: none;\r\n    justify-self: center;\r\n    z-index: 1000;\r\n  }\r\n\r\n  .A8_2_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 300px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 60px;\r\n    width: 60px;\r\n    border-radius: 50%;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    display: none;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .Info__8 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__8__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__8__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__8__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen4 img {\r\n    object-fit: cover;\r\n    object-position: 50% 20%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_9_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Info__9__title {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    justify-self: center;\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info_9_title_1 {\r\n    grid-column: 1 / 2;\r\n  }\r\n\r\n  .Info_9_title_2 {\r\n    grid-column: 2 / 3;\r\n  }\r\n\r\n  .A9_1_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A9_2_Animation {\r\n    grid-column: 3 / 5;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: -3svh;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__9 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__9__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__9__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__9__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_9 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_9 img {\r\n    object-fit: cover;\r\n    object-position: 50% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_10_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 15.7%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 68.6%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .A10_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: auto;\r\n    width: 80%;\r\n    z-index: 40;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__10 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__10__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__10__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__10__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_10 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_10 img {\r\n    object-fit: cover;\r\n    object-position: 50% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .endAforismos {\r\n    display: grid;\r\n    color: white;\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 100vw;\r\n    justify-content: center !important;\r\n    align-items: center;\r\n  }\r\n\r\n  .BG_info {\r\n    position: fixed;\r\n    left: 50%;\r\n    bottom: 5%;\r\n    color: white;\r\n  }\r\n\r\n  .BG_info h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    line-height: 1em;\r\n  }\r\n\r\n  .BG_info p {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1025px) and (max-width: 1440px) {\r\n  /* Laptop L */\r\n\r\n  /* Aforismos */\r\n\r\n  .Theory__Aforismos {\r\n    background-color: black;\r\n    height: 500svh;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_1_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 10%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line {\r\n    grid-column: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    border: 1px solid white;\r\n    min-height: 50%;\r\n    z-index: 2;\r\n    justify-self: right;\r\n    align-self: flex-start;\r\n    margin: 0;\r\n    display: none;\r\n  }\r\n\r\n  .Info__1 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: relative;\r\n    top: 10%;\r\n    left: -1.5rem;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__1__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__1__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__1__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_1 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_1 img {\r\n    object-fit: cover;\r\n    object-position: 50% 80%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_2_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 80svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 10%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    width: 100%;\r\n  }\r\n\r\n  .A2_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 2.5rem;\r\n    left: 3.8rem;\r\n    color: white;\r\n    height: 290px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n  }\r\n\r\n  .Info__2 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 2 / 3;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__2__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__2__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__2__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .line2 {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 41%;\r\n    color: white;\r\n    border-left: 20px solid white;\r\n    min-height: 605px;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .fullscreen_2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_2 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_3_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 10%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .A3_Animation {\r\n    position: fixed;\r\n    bottom: 100%;\r\n    left: 45%;\r\n    color: white;\r\n    height: 190px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__3 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__3__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__3__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__3__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen2 {\r\n    height: 75svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 12.5%;\r\n    left: 0;\r\n    padding-left: 2.5vw;\r\n    padding-right: 2.5vw;\r\n  }\r\n\r\n  .fullscreen2 img {\r\n    object-fit: contain;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_4_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 10%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .A4_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 5rem;\r\n    left: 0;\r\n    color: white;\r\n    height: auto;\r\n    width: 100%;\r\n    z-index: 2;\r\n    display: none;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Info__4 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__4__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__4__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__4__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_4 img {\r\n    object-fit: cover;\r\n    object-position: 50% 80%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_5_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 10%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_5_Animation_Grid {\r\n    grid-column: 3 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    gap: 0;\r\n    grid-template-columns: 1fr 1fr;\r\n    color: white;\r\n    position: static;\r\n  }\r\n\r\n  .A5_1_Animation {\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A5_2_Animation {\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__5 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__5__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__5__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__5__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen3 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen3 img {\r\n    object-fit: scale-down;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_6_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 10%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    width: 100%;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__6 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__6__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__6__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__6__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  /* src/MouseParallax.css */\r\n  .mouse-parallax-container {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .background-blurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: blur(2px); /* Add a blur effect to the background */\r\n  }\r\n\r\n  .background-unblurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: none; /* No blur effect on the unblurred content */\r\n  }\r\n\r\n  .mouse-cursor {\r\n    position: absolute;\r\n    width: 100px;\r\n    height: 100px;\r\n    border: 2px solid #fff;\r\n    border-radius: 50%;\r\n    pointer-events: none; /* Prevent cursor from affecting other elements */\r\n    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  .fullscreen_6 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_6 img {\r\n    object-fit: cover;\r\n    object-position: 50% 80%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_7_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 10%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .A7_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__7 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__7__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__7__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__7__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo_8_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 10%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .A8_1_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .A8_2_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 50%;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    display: none;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .Info__8 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__8__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__8__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__8__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen4 img {\r\n    object-fit: cover;\r\n    object-position: 50% 20%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_9_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 10%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Info__9__title {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    justify-self: center;\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info_9_title_1 {\r\n    grid-column: 1 / 2;\r\n  }\r\n\r\n  .Info_9_title_2 {\r\n    grid-column: 2 / 3;\r\n  }\r\n\r\n  .A9_1_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A9_2_Animation {\r\n    grid-column: 3 / 5;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: -1.5rem;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__9 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__9__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__9__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__9__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_9 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_9 img {\r\n    object-fit: cover;\r\n    object-position: 50% 80%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_10_Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 10%;\r\n    top: 0;\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .A10_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: auto;\r\n    width: 80%;\r\n    z-index: 40;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__10 {\r\n    display: grid;\r\n    grid-column: 2 / 5;\r\n    grid-row: 1 / 2;\r\n    grid-template-columns: 1fr 1.9fr;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__10__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__10__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__10__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_10 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_10 img {\r\n    object-fit: cover;\r\n    object-position: 100% 80%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .endAforismos {\r\n    display: grid;\r\n    color: white;\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 100vw;\r\n    justify-content: center !important;\r\n    align-items: center;\r\n  }\r\n\r\n  .BG_info {\r\n    position: fixed;\r\n    left: 10%;\r\n    bottom: 10%;\r\n    color: white;\r\n  }\r\n\r\n  .BG_info h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    line-height: 1em;\r\n  }\r\n\r\n  .BG_info p {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 769px) and (max-width: 1024px) {\r\n  /* Laptop aka Tablet L */\r\n\r\n  .Theory {\r\n    display: grid;\r\n    justify-content: center;\r\n    align-items: start;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    height: 200svh;\r\n    max-width: 68.6%;\r\n    text-align: center;\r\n  }\r\n\r\n  .image-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    justify-content: center;\r\n    justify-self: center !important;\r\n    transition: transform 0.3s ease, opacity 0.3s ease;\r\n    scroll-behavior: smooth;\r\n    width: fit-content;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .rotating-image {\r\n    max-width: 800px;\r\n    max-height: 800px;\r\n    width: auto;\r\n    height: auto;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .Tecno__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Tecno__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Tecno__Text p {\r\n    justify-self: start;\r\n  }\r\n\r\n  .Tecno__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Autor__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Autor__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Autor__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Programa__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Programa__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Programa__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Design__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Design__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: center;\r\n    display: flex;\r\n  }\r\n\r\n  .Design__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .NextButton {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 0;\r\n    justify-self: center;\r\n    align-self: center;\r\n    height: auto;\r\n  }\r\n\r\n  .Tecno__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Autor__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Programa__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Design__Section {\r\n    display: none;\r\n  }\r\n\r\n  .show {\r\n    display: grid;\r\n    z-index: 10;\r\n  }\r\n\r\n  /* Aforismos */\r\n\r\n  .Theory__Aforismos {\r\n    background-color: black;\r\n    height: 500svh;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_1_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    border: 1px solid white;\r\n    min-height: 30%;\r\n    z-index: 2;\r\n    justify-self: left;\r\n    align-self: flex-start;\r\n    margin: 0;\r\n    display: none;\r\n  }\r\n\r\n  .Info__1 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: relative;\r\n    top: 2rem;\r\n    left: 0;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__1__1 h1 {\r\n    font-size: 20px;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__1__1 p {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .Info__1__2 p {\r\n    font-size: 20px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_1 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_1 img {\r\n    object-fit: cover;\r\n    object-position: 50% 80%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .BG_info {\r\n    position: fixed;\r\n    left: 5%;\r\n    bottom: 5%;\r\n    color: white;\r\n  }\r\n\r\n  .BG_info h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    line-height: 1em;\r\n  }\r\n\r\n  .BG_info p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Aforismo_2_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 87.75svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A2_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: fixed;\r\n    top: 0.2rem;\r\n    left: -2.725rem;\r\n    color: white;\r\n    height: 290px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Info__2 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: fixed;\r\n    top: 17.05rem;\r\n    left: 3.3rem;\r\n    max-width: 90%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__2__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__2__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__2__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_2 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_3_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line2 {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 10%;\r\n    color: white;\r\n    border-left: 20px solid white;\r\n    min-height: 605px;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .A3_Animation {\r\n    position: fixed;\r\n    bottom: 100%;\r\n    left: 15%;\r\n    color: white;\r\n    height: 190px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__3 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__3__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__3__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__3__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen2 img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_4_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A4_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 5rem;\r\n    left: 0;\r\n    color: white;\r\n    height: auto;\r\n    width: 100%;\r\n    z-index: 2;\r\n    display: none;\r\n    align-self: self-end;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__4 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: fixed;\r\n    top: 20rem;\r\n    left: 3rem;\r\n    max-width: 90%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__4__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__4__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__4__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_4 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_5_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_5_Animation_Grid {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    gap: 0;\r\n    grid-template-columns: 1fr 1fr;\r\n    color: white;\r\n    position: static;\r\n    width: 100%;\r\n  }\r\n\r\n  .A5_1_Animation {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    justify-self: end;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .A5_2_Animation {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__5 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__5__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__5__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__5__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen3 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen3 img {\r\n    object-fit: scale-down;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_6_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__6 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__6__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__6__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__6__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  /* src/MouseParallax.css */\r\n  .mouse-parallax-container {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .background-blurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: blur(2px); /* Add a blur effect to the background */\r\n  }\r\n\r\n  .background-unblurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: none; /* No blur effect on the unblurred content */\r\n  }\r\n\r\n  .mouse-cursor {\r\n    position: absolute;\r\n    width: 100px;\r\n    height: 100px;\r\n    border: 2px solid #fff;\r\n    border-radius: 50%;\r\n    pointer-events: none; /* Prevent cursor from affecting other elements */\r\n    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  .fullscreen_6 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_6 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_7_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A7_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 500px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__7 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__7__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__7__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__7__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo_8_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A8_1_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .A8_2_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 50%;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    display: none;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .Info__8 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__8__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__8__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__8__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen4 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_9_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__9__title {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    justify-self: center;\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info_9_title_1 {\r\n    grid-column: 1 / 2;\r\n  }\r\n\r\n  .Info_9_title_2 {\r\n    grid-column: 2 / 3;\r\n  }\r\n\r\n  .A9_1_Animation {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 150px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A9_2_Animation {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: -1rem;\r\n    color: white;\r\n    height: 150px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__9 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__9__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__9__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__9__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_9 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_9 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_10_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A10_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: auto;\r\n    width: 100%;\r\n    z-index: 40;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__10 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__10__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__10__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__10__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_10 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_10 img {\r\n    object-fit: cover;\r\n    object-position: 70% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 426px) and (max-width: 768px) {\r\n  .Theory {\r\n    display: grid;\r\n    justify-content: center;\r\n    align-items: start;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    height: 200svh;\r\n    max-width: 89.5%;\r\n    text-align: center;\r\n    padding-top: 17svh;\r\n  }\r\n\r\n  .Theory__Caption {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    align-items: start;\r\n    margin: 0 auto;\r\n    width: 89.5%;\r\n    position: sticky;\r\n    bottom: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .Theory__Caption p {\r\n    grid-column: 1 / 2;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n    padding-bottom: 1.5em;\r\n  }\r\n\r\n  .Theory__Caption2 {\r\n    display: none;\r\n  }\r\n\r\n  .image-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    justify-content: center;\r\n    justify-self: center !important;\r\n    transition: transform 0.3s ease, opacity 0.3s ease;\r\n    scroll-behavior: smooth;\r\n    width: min-content;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .rotating-image {\r\n    max-width: 400px; /* Adjusted for better mobile responsiveness */\r\n    height: auto;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .teste__mobile {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100svh;\r\n    width: 100vw;\r\n    display: grid;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Triangle_main_mobile {\r\n    display: flex !important;\r\n    max-width: 100vw;\r\n    height: 100svh;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .FixImages {\r\n    height: 100svh !important;\r\n    max-width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-left: 1em;\r\n    margin-right: 1em;\r\n  }\r\n\r\n  /*Tablet*/\r\n\r\n  .Tecno__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Tecno__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Tecno__Text p {\r\n    justify-self: start;\r\n  }\r\n\r\n  .Tecno__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Autor__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Autor__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Autor__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Programa__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Programa__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Programa__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Design__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Design__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: center;\r\n    display: flex;\r\n  }\r\n\r\n  .Design__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .NextButton {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 0;\r\n    justify-self: center;\r\n    align-self: center;\r\n    height: auto;\r\n  }\r\n\r\n  .Tecno__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Autor__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Programa__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Design__Section {\r\n    display: none;\r\n  }\r\n\r\n  .show {\r\n    display: grid;\r\n    z-index: 10;\r\n  }\r\n\r\n  .workplz {\r\n    max-height: 100svh !important;\r\n    max-width: 100vw !important;\r\n    width: 90%;\r\n    height: auto;\r\n  }\r\n\r\n  .TecnoMobile {\r\n    height: 30vw;\r\n    width: 20vw;\r\n    border: pink 1px solid;\r\n  }\r\n\r\n  .testeBG {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .img-responsive {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n\r\n  .img-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    text-align: center;\r\n  }\r\n\r\n  /* Aforismos */\r\n\r\n  .Theory__Aforismos {\r\n    background-color: black;\r\n    height: 500svh;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_1_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    border: 1px solid white;\r\n    min-height: 30%;\r\n    z-index: 2;\r\n    justify-self: left;\r\n    align-self: flex-start;\r\n    margin: 0;\r\n    display: none;\r\n  }\r\n\r\n  .Info__1 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__1__1 h1 {\r\n    font-size: 20px;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__1__1 p {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .Info__1__2 p {\r\n    font-size: 20px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_1 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_1 img {\r\n    object-fit: cover;\r\n    object-position: 50% 80%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .BG_info {\r\n    position: fixed;\r\n    left: 5%;\r\n    bottom: 2.5%;\r\n    color: white;\r\n  }\r\n\r\n  .BG_info h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    line-height: 1em;\r\n  }\r\n\r\n  .BG_info p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Aforismo_2_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 87.75svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A2_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: fixed;\r\n    top: -1.5rem;\r\n    left: -3.6rem;\r\n    color: white;\r\n    height: 290px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Info__2 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: fixed;\r\n    top: 15.4rem;\r\n    left: 2.4rem;\r\n    max-width: 90%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__2__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__2__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__2__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_2 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_3_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line2 {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 10%;\r\n    color: white;\r\n    border-left: 20px solid white;\r\n    min-height: 605px;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .A3_Animation {\r\n    position: fixed;\r\n    bottom: 100%;\r\n    left: 15%;\r\n    color: white;\r\n    height: 190px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__3 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__3__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__3__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__3__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen2 img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_4_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A4_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 5rem;\r\n    left: 0;\r\n    color: white;\r\n    height: auto;\r\n    width: 100%;\r\n    z-index: 2;\r\n    display: none;\r\n    align-self: self-start;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__4 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n    z-index: 10;\r\n  }\r\n\r\n  .Info__4__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__4__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__4__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_4 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_5_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_5_Animation_Grid {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    gap: 0;\r\n    grid-template-columns: 1fr 1fr;\r\n    color: white;\r\n    position: static;\r\n    width: 100%;\r\n  }\r\n\r\n  .A5_1_Animation {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    justify-self: end;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .A5_2_Animation {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__5 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__5__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__5__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__5__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen3 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen3 img {\r\n    object-fit: scale-down;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_6_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__6 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__6__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__6__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__6__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  /* src/MouseParallax.css */\r\n  .mouse-parallax-container {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .background-blurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: blur(2px); /* Add a blur effect to the background */\r\n  }\r\n\r\n  .background-unblurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: none; /* No blur effect on the unblurred content */\r\n  }\r\n\r\n  .mouse-cursor {\r\n    position: absolute;\r\n    width: 100px;\r\n    height: 100px;\r\n    border: 2px solid #fff;\r\n    border-radius: 50%;\r\n    pointer-events: none; /* Prevent cursor from affecting other elements */\r\n    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  .fullscreen_6 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_6 img {\r\n    object-fit: cover;\r\n    object-position: 20% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_7_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A7_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 350px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__7 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__7__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__7__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__7__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo_8_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A8_1_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .A8_2_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 50%;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    display: none;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .Info__8 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__8__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__8__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__8__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen4 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_9_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__9__title {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    justify-self: center;\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info_9_title_1 {\r\n    grid-column: 1 / 2;\r\n  }\r\n\r\n  .Info_9_title_2 {\r\n    grid-column: 2 / 3;\r\n  }\r\n\r\n  .A9_1_Animation {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 150px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A9_2_Animation {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: -1rem;\r\n    color: white;\r\n    height: 150px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__9 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__9__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__9__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__9__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_9 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_9 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_10_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A10_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 30%;\r\n    width: auto;\r\n    z-index: 40;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__10 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__10__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__10__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__10__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_10 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_10 img {\r\n    object-fit: cover;\r\n    object-position: 65% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 376px) and (max-width: 425px) {\r\n  /* Mobile L*/\r\n\r\n  .Theory {\r\n    display: grid;\r\n    justify-content: center;\r\n    align-items: start;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    height: 200svh;\r\n    max-width: 89.5%;\r\n    text-align: center;\r\n    padding-top: 19svh;\r\n  }\r\n\r\n  .Theory__Caption {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    align-items: start;\r\n    margin: 0 auto;\r\n    width: 89.5%;\r\n    position: sticky;\r\n    bottom: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .Theory__Caption p {\r\n    grid-column: 1 / 2;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n    padding-bottom: 1.5em;\r\n  }\r\n\r\n  .Theory__Caption2 {\r\n    display: none;\r\n  }\r\n\r\n  .image-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    justify-content: center;\r\n    justify-self: center !important;\r\n    transition: transform 0.3s ease, opacity 0.3s ease;\r\n    scroll-behavior: smooth;\r\n    width: min-content;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .rotating-image {\r\n    max-width: 350px; /* Adjusted for better mobile responsiveness */\r\n    height: auto;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .Tecno__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Tecno__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Tecno__Text p {\r\n    justify-self: start;\r\n  }\r\n\r\n  .Tecno__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Autor__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Autor__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Autor__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Programa__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Programa__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Programa__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Design__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Design__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: center;\r\n    display: flex;\r\n  }\r\n\r\n  .Design__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .NextButton {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 0;\r\n    justify-self: center;\r\n    align-self: center;\r\n    height: auto;\r\n  }\r\n\r\n  .Tecno__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Autor__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Programa__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Design__Section {\r\n    display: none;\r\n  }\r\n\r\n  .show {\r\n    display: grid;\r\n    z-index: 10;\r\n  }\r\n\r\n  /* Aforismos */\r\n\r\n  .Theory__Aforismos {\r\n    background-color: black;\r\n    height: 500svh;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_1_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    border: 1px solid white;\r\n    min-height: 30%;\r\n    z-index: 2;\r\n    justify-self: left;\r\n    align-self: flex-start;\r\n    margin: 0;\r\n    display: none;\r\n  }\r\n\r\n  .Info__1 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__1__1 h1 {\r\n    font-size: 20px;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__1__1 p {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .Info__1__2 p {\r\n    font-size: 20px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_1 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_1 img {\r\n    object-fit: cover;\r\n    object-position: 50% 80%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .BG_info {\r\n    position: fixed;\r\n    left: 5%;\r\n    bottom: 5%;\r\n    color: white;\r\n  }\r\n\r\n  .BG_info h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    line-height: 1em;\r\n  }\r\n\r\n  .BG_info p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Aforismo_2_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 87.75svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A2_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: fixed;\r\n    top: -1.5rem;\r\n    left: -3.6rem;\r\n    color: white;\r\n    height: 290px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Info__2 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: fixed;\r\n    top: 15.4rem;\r\n    left: 2.4rem;\r\n    max-width: 90%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__2__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__2__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__2__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_2 img {\r\n    object-fit: cover;\r\n    object-position: 55% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_3_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line2 {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 10%;\r\n    color: white;\r\n    border-left: 20px solid white;\r\n    min-height: 605px;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .A3_Animation {\r\n    position: fixed;\r\n    bottom: 100%;\r\n    left: 15%;\r\n    color: white;\r\n    height: 190px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__3 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__3__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__3__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__3__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen2 {\r\n    height: 90%;\r\n    width: 89.5%;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 5.25%;\r\n  }\r\n\r\n  .fullscreen2 img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_4_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A4_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 5rem;\r\n    left: 0;\r\n    color: white;\r\n    height: auto;\r\n    width: 100%;\r\n    z-index: 2;\r\n    display: none;\r\n    align-self: self-start;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__4 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__4__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__4__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__4__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_4 img {\r\n    object-fit: cover;\r\n    object-position: 52.5% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_5_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_5_Animation_Grid {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    gap: 0;\r\n    grid-template-columns: 1fr 1fr;\r\n    color: white;\r\n    position: static;\r\n    width: 100%;\r\n  }\r\n\r\n  .A5_1_Animation {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    justify-self: end;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .A5_2_Animation {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__5 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__5__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__5__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__5__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen3 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen3 img {\r\n    object-fit: scale-down;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_6_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__6 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__6__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__6__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__6__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  /* src/MouseParallax.css */\r\n  .mouse-parallax-container {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .background-blurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: blur(2px); /* Add a blur effect to the background */\r\n  }\r\n\r\n  .background-unblurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: none; /* No blur effect on the unblurred content */\r\n  }\r\n\r\n  .mouse-cursor {\r\n    position: absolute;\r\n    width: 100px;\r\n    height: 100px;\r\n    border: 2px solid #fff;\r\n    border-radius: 50%;\r\n    pointer-events: none; /* Prevent cursor from affecting other elements */\r\n    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  .fullscreen_6 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_6 img {\r\n    object-fit: cover;\r\n    object-position: 30% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_7_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A7_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 350px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__7 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__7__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__7__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__7__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo_8_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A8_1_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .A8_2_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 250px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 50px;\r\n    width: 50px;\r\n    border-radius: 50%;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    display: none;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .Info__8 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__8__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__8__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__8__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen4 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_9_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__9__title {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    justify-self: center;\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info_9_title_1 {\r\n    grid-column: 1 / 2;\r\n  }\r\n\r\n  .Info_9_title_2 {\r\n    grid-column: 2 / 3;\r\n  }\r\n\r\n  .A9_1_Animation {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 150px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A9_2_Animation {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: -1rem;\r\n    color: white;\r\n    height: 150px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__9 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__9__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__9__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__9__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_9 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_9 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_10_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A10_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 25%;\r\n    width: auto;\r\n    z-index: 40;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__10 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__10__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__10__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__10__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_10 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_10 img {\r\n    object-fit: cover;\r\n    object-position: 62.5% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .BG_info {\r\n    position: fixed;\r\n    left: 5%;\r\n    bottom: 2.5%;\r\n    color: white;\r\n  }\r\n\r\n  .BG_info h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    line-height: 1em;\r\n  }\r\n\r\n  .BG_info p {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 321px) and (max-width: 375px) {\r\n  /* Mobile M */\r\n\r\n  .Theory {\r\n    display: grid;\r\n    justify-content: center;\r\n    align-items: start;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    height: 200svh;\r\n    max-width: 89.5%;\r\n    text-align: center;\r\n    padding-top: 21svh;\r\n  }\r\n\r\n  .Theory__Caption {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    align-items: start;\r\n    margin: 0 auto;\r\n    width: 89.5%;\r\n    position: sticky;\r\n    bottom: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .Theory__Caption p {\r\n    grid-column: 1 / 2;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n    padding-bottom: 1.5em;\r\n  }\r\n\r\n  .Theory__Caption2 {\r\n    display: none;\r\n  }\r\n\r\n  .image-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    justify-content: center;\r\n    justify-self: center !important;\r\n    transition: transform 0.3s ease, opacity 0.3s ease;\r\n    scroll-behavior: smooth;\r\n    width: min-content;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .rotating-image {\r\n    max-width: 300px; /* Adjusted for better mobile responsiveness */\r\n    height: auto;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .Tecno__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Tecno__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Tecno__Text p {\r\n    justify-self: start;\r\n  }\r\n\r\n  .Tecno__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Autor__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Autor__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Autor__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Programa__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Programa__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Programa__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Design__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Design__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: center;\r\n    display: flex;\r\n  }\r\n\r\n  .Design__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .NextButton {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 0;\r\n    justify-self: center;\r\n    align-self: center;\r\n    height: auto;\r\n  }\r\n\r\n  .Tecno__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Autor__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Programa__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Design__Section {\r\n    display: none;\r\n  }\r\n\r\n  .show {\r\n    display: grid;\r\n    z-index: 10;\r\n  }\r\n\r\n  /* Aforismos */\r\n\r\n  .Theory__Aforismos {\r\n    background-color: black;\r\n    height: 500svh;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_1_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    border: 1px solid white;\r\n    min-height: 30%;\r\n    z-index: 2;\r\n    justify-self: left;\r\n    align-self: flex-start;\r\n    margin: 0;\r\n    display: none;\r\n  }\r\n\r\n  .Info__1 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__1__1 h1 {\r\n    font-size: 20px;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__1__1 p {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .Info__1__2 p {\r\n    font-size: 20px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_1 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_1 img {\r\n    object-fit: cover;\r\n    object-position: 65% 80%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .BG_info {\r\n    position: fixed;\r\n    left: 5%;\r\n    bottom: 5%;\r\n    color: white;\r\n  }\r\n\r\n  .BG_info h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    line-height: 1em;\r\n  }\r\n\r\n  .BG_info p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Aforismo_2_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 87.75svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A2_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: fixed;\r\n    top: -1.5rem;\r\n    left: -3.6rem;\r\n    color: white;\r\n    height: 290px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Info__2 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: fixed;\r\n    top: 15.4rem;\r\n    left: 2.4rem;\r\n    max-width: 80%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__2__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__2__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__2__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_2 img {\r\n    object-fit: cover;\r\n    object-position: 55% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_3_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line2 {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 10%;\r\n    color: white;\r\n    border-left: 20px solid white;\r\n    min-height: 605px;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .A3_Animation {\r\n    position: fixed;\r\n    bottom: 100%;\r\n    left: 15%;\r\n    color: white;\r\n    height: 190px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__3 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__3__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__3__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__3__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen2 img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_4_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A4_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 5rem;\r\n    left: 0;\r\n    color: white;\r\n    height: auto;\r\n    width: 100%;\r\n    z-index: 2;\r\n    display: none;\r\n    align-self: self-start;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__4 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__4__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__4__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__4__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_4 img {\r\n    object-fit: cover;\r\n    object-position: 52.5% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_5_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_5_Animation_Grid {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    gap: 0;\r\n    grid-template-columns: 1fr 1fr;\r\n    color: white;\r\n    position: static;\r\n    width: 100%;\r\n  }\r\n\r\n  .A5_1_Animation {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    justify-self: end;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .A5_2_Animation {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__5 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__5__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__5__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__5__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen3 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen3 img {\r\n    object-fit: scale-down;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_6_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__6 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__6__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__6__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__6__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  /* src/MouseParallax.css */\r\n  .mouse-parallax-container {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .background-blurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: blur(2px); /* Add a blur effect to the background */\r\n  }\r\n\r\n  .background-unblurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: none; /* No blur effect on the unblurred content */\r\n  }\r\n\r\n  .mouse-cursor {\r\n    position: absolute;\r\n    width: 100px;\r\n    height: 100px;\r\n    border: 2px solid #fff;\r\n    border-radius: 50%;\r\n    pointer-events: none; /* Prevent cursor from affecting other elements */\r\n    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  .fullscreen_6 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_6 img {\r\n    object-fit: cover;\r\n    object-position: 30% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_7_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A7_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 300px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__7 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__7__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__7__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__7__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo_8_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A8_1_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .A8_2_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 40px;\r\n    width: 40px;\r\n    border-radius: 50%;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    display: none;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .Info__8 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__8__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__8__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__8__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen4 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_9_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__9__title {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 20px;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    justify-self: center;\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info_9_title_1 {\r\n    grid-column: 1 / 2;\r\n  }\r\n\r\n  .Info_9_title_2 {\r\n    grid-column: 2 / 3;\r\n  }\r\n\r\n  .A9_1_Animation {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 150px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A9_2_Animation {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: -1rem;\r\n    color: white;\r\n    height: 150px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__9 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__9__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__9__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__9__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_9 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_9 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_10_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A10_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 20%;\r\n    width: auto;\r\n    z-index: 40;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__10 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__10__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__10__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__10__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_10 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_10 img {\r\n    object-fit: cover;\r\n    object-position: 62.5% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 320px) {\r\n  /* Mobile S*/\r\n\r\n  .Theory {\r\n    display: grid;\r\n    justify-content: center;\r\n    align-items: start;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    height: 200svh;\r\n    max-width: 89.5%;\r\n    text-align: center;\r\n    padding-top: 23svh;\r\n  }\r\n\r\n  .Theory__Caption {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    align-items: start;\r\n    margin: 0 auto;\r\n    width: 89.5%;\r\n    position: sticky;\r\n    bottom: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .Theory__Caption p {\r\n    grid-column: 1 / 2;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n    padding-bottom: 1.5em;\r\n  }\r\n\r\n  .Theory__Caption2 {\r\n    display: none;\r\n  }\r\n\r\n  .image-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    justify-content: center;\r\n    justify-self: center !important;\r\n    transition: transform 0.3s ease, opacity 0.3s ease;\r\n    scroll-behavior: smooth;\r\n    width: min-content;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .rotating-image {\r\n    max-width: 250px; /* Adjusted for better mobile responsiveness */\r\n    height: auto;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .Tecno__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Tecno__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Tecno__Text p {\r\n    justify-self: start;\r\n  }\r\n\r\n  .Tecno__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Autor__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Autor__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Autor__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Programa__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Programa__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: start;\r\n    display: flex;\r\n  }\r\n\r\n  .Programa__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Design__Section {\r\n    position: absolute;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 0;\r\n    top: 0;\r\n    height: 100svh;\r\n    width: 89%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Design__Text {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    width: 100%;\r\n    position: static;\r\n    justify-self: center;\r\n    align-items: center;\r\n    height: auto;\r\n    align-self: center;\r\n    display: flex;\r\n  }\r\n\r\n  .Design__Button {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 25px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .NextButton {\r\n    grid-column: 1 / 3;\r\n    grid-row: 2 / 3;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    opacity: 60%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    box-shadow: none;\r\n    position: relative;\r\n    bottom: 125px;\r\n    justify-self: center;\r\n    align-self: self-end;\r\n    height: auto;\r\n  }\r\n\r\n  .Tecno__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Autor__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Programa__Section {\r\n    display: none;\r\n  }\r\n\r\n  .Design__Section {\r\n    display: none;\r\n  }\r\n\r\n  .show {\r\n    display: grid;\r\n    z-index: 10;\r\n  }\r\n\r\n  /* Aforismos */\r\n\r\n  .Theory__Aforismos {\r\n    background-color: black;\r\n    height: 500svh;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_1_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    border: 1px solid white;\r\n    min-height: 30%;\r\n    z-index: 2;\r\n    justify-self: left;\r\n    align-self: flex-start;\r\n    margin: 0;\r\n    display: none;\r\n  }\r\n\r\n  .Info__1 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: relative;\r\n    top: 1rem;\r\n    left: 0;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__1__1 h1 {\r\n    font-size: 20px;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__1__1 p {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .Info__1__2 p {\r\n    font-size: 20px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_1 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_1 img {\r\n    object-fit: cover;\r\n    object-position: 65% 80%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .BG_info {\r\n    position: fixed;\r\n    left: 5%;\r\n    bottom: 5%;\r\n    color: white;\r\n  }\r\n\r\n  .BG_info h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    line-height: 1em;\r\n  }\r\n\r\n  .BG_info p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Aforismo_2_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 87.75svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A2_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: fixed;\r\n    top: -1.5rem;\r\n    left: -3.6rem;\r\n    color: white;\r\n    height: 290px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n    align-self: self-start;\r\n  }\r\n\r\n  .Info__2 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: fixed;\r\n    top: 15.4rem;\r\n    left: 2.4rem;\r\n    max-width: 80%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__2__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__2__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__2__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_2 img {\r\n    object-fit: cover;\r\n    object-position: 55% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_3_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .line2 {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 10%;\r\n    color: white;\r\n    border-left: 20px solid white;\r\n    min-height: 605px;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .A3_Animation {\r\n    position: fixed;\r\n    bottom: 100%;\r\n    left: 15%;\r\n    color: white;\r\n    height: 190px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__3 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info__3__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__3__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__3__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen2 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen2 img {\r\n    object-fit: contain;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_4_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A4_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 5rem;\r\n    left: 0;\r\n    color: white;\r\n    height: auto;\r\n    width: 100%;\r\n    z-index: 2;\r\n    display: none;\r\n    align-self: self-start;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__4 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__4__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__4__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__4__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_4 img {\r\n    object-fit: cover;\r\n    object-position: 52.5% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_5_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Aforismo_5_Animation_Grid {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    gap: 0;\r\n    grid-template-columns: 1fr 1fr;\r\n    color: white;\r\n    position: static;\r\n    width: 100%;\r\n  }\r\n\r\n  .A5_1_Animation {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    justify-self: end;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .A5_2_Animation {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    justify-self: start;\r\n    color: white;\r\n    height: 100%;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n  }\r\n\r\n  .Info__5 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__5__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__5__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__5__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen3 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen3 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_6_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__6 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__6__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__6__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__6__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  /* src/MouseParallax.css */\r\n  .mouse-parallax-container {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .background-blurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: blur(2px); /* Add a blur effect to the background */\r\n  }\r\n\r\n  .background-unblurred {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: none; /* No blur effect on the unblurred content */\r\n  }\r\n\r\n  .mouse-cursor {\r\n    position: absolute;\r\n    width: 100px;\r\n    height: 100px;\r\n    border: 2px solid #fff;\r\n    border-radius: 50%;\r\n    pointer-events: none; /* Prevent cursor from affecting other elements */\r\n    mix-blend-mode: exclusion; /* Blend mode to create the blur effect */\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  .fullscreen_6 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_6 img {\r\n    object-fit: cover;\r\n    object-position: 30% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_7_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A7_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 300px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__7 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__7__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__7__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__7__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Aforismo_8_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A8_1_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .A8_2_Animation {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 200px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .cursor {\r\n    background-color: #ffffff;\r\n    height: 40px;\r\n    width: 40px;\r\n    border-radius: 50%;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    display: none;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .Info__8 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__8__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__8__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__8__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen4 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen4 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_9_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .Info__9__title {\r\n    grid-column: 1 / 5;\r\n    grid-row: 1 / 2;\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    justify-self: center;\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n\r\n  .Info_9_title_1 {\r\n    grid-column: 1 / 2;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .Info_9_title_2 {\r\n    grid-column: 2 / 3;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .A9_1_Animation {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 150px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: right;\r\n  }\r\n\r\n  .A9_2_Animation {\r\n    grid-column: 2 / 3;\r\n    grid-row: 1 / 2;\r\n    position: relative;\r\n    top: 0;\r\n    left: -1rem;\r\n    color: white;\r\n    height: 150px;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: none;\r\n    justify-self: left;\r\n  }\r\n\r\n  .Info__9 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__9__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__9__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__9__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info_9_title_1 {\r\n    font-size: 16px !important;\r\n  }\r\n\r\n  .Info_9_title_2 {\r\n    font-size: 16px !important;\r\n  }\r\n\r\n  .fullscreen_9 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_9 img {\r\n    object-fit: cover;\r\n    object-position: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n  .Aforismo_10_Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    color: white;\r\n    height: 100svh;\r\n    position: fixed;\r\n    margin: 0 auto;\r\n    left: 5.25%;\r\n    top: 0;\r\n    max-width: 89.5%;\r\n    width: 100%;\r\n    justify-items: left;\r\n    align-items: center;\r\n  }\r\n\r\n  .A10_Animation {\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    position: static;\r\n    color: white;\r\n    height: 20%;\r\n    width: auto;\r\n    z-index: 40;\r\n    display: none;\r\n    justify-self: center;\r\n  }\r\n\r\n  .Info__10 {\r\n    display: grid;\r\n    grid-column: 1 / 3;\r\n    grid-row: 1 / 2;\r\n    grid-template-rows: 1fr;\r\n    gap: 1rem;\r\n    color: white;\r\n    position: static;\r\n    max-width: 100%;\r\n    align-items: start;\r\n    justify-self: start;\r\n  }\r\n\r\n  .Info__10__1 h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n\r\n  .Info__10__1 p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .Info__10__2 p {\r\n    font-size: 18px;\r\n    margin: 0;\r\n  }\r\n\r\n  .fullscreen_10 {\r\n    height: 100svh;\r\n    width: 100vw;\r\n    z-index: 10;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n\r\n  .fullscreen_10 img {\r\n    object-fit: cover;\r\n    object-position: 62.5% 50%;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
